var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgFlipBack1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 212,
    viewBox: "0 0 342 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_150_150)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 212,
    rx: 20,
    fill: "url(#paint0_linear_150_150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447 122.094C545 395.094 252.28 380.594 112 380.594C-28.2803 380.594 -142 272.023 -142 138.094C-142 4.16454 -64.2803 183.094 76 183.094C217.5 190.094 349 -84.4063 447 122.094Z",
    fill: "#9A4ED5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_150_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.667 93.6426C213.726 95.9823 213.902 98.3222 214.311 100.546C213.96 100.779 213.596 101.013 213.231 101.246C212.864 101.481 212.497 101.715 212.145 101.95L212.14 101.943V101.957L212.1 101.996C211.691 99.8325 211.399 97.6691 211.282 95.4473C211.692 95.1547 212.087 94.8479 212.481 94.541C212.872 94.237 213.262 93.9323 213.667 93.6426Z",
    fill: "#FFBC00",
    fillOpacity: 0.368627,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.871 74.2601C305.216 79.8928 306.506 86.1114 306.506 92.6234V93.6742C305.691 94.3144 304.877 94.9539 304.005 95.5365C304.062 94.6045 304.063 93.6721 304.063 92.7406C304.063 86.6939 302.889 80.9406 300.777 75.7152C301.475 75.192 302.173 74.7257 302.871 74.2601Z",
    fill: "#FFBC00",
    fillOpacity: 0.368627,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.835 45.0117C285.163 45.0118 306.506 66.3547 306.506 92.6826C306.506 119.01 285.163 140.353 258.835 140.354C232.508 140.354 211.165 119.01 211.165 92.6826C211.165 66.3546 232.507 45.0117 258.835 45.0117Z",
    fill: "url(#paint1_linear_150_150)",
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.692 76.2578C305.568 81.3615 306.565 86.8756 306.565 92.624V93.6152C304.335 95.1996 302.091 96.7549 299.839 98.3027L293.064 102.949C287.258 106.906 281.452 110.818 275.763 114.881L273.333 116.632C270.221 118.893 267.123 121.198 264.025 123.503C260.93 125.806 257.835 128.108 254.725 130.367L254.718 130.373C251.137 132.956 247.556 135.479 243.975 137.827C237.055 135.597 230.837 131.727 225.733 126.802C228.108 125.19 230.512 123.592 232.923 122.002L240.168 117.237C244.924 114.11 249.714 111.017 254.511 107.932L259.311 104.848C262.482 102.792 265.667 100.751 268.86 98.7109L278.454 92.5742C284.854 88.4639 291.255 84.3527 297.655 80.1836L297.656 80.1846C299.707 78.8954 301.7 77.6054 303.692 76.2578Z",
    fill: "#FFF5BB",
    fillOpacity: 0.368627,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.574 47.6542C277.502 48.6498 280.312 49.9967 282.948 51.5184C282.425 51.867 281.916 52.2017 281.407 52.536L279.852 53.5643C274.56 57.1096 269.267 60.6099 264.014 64.1835L261.765 65.7196C256.524 69.3163 251.283 72.9132 246.081 76.5887L243.855 78.1688C238.922 81.714 233.989 85.3044 229.135 89.0184L227.06 90.618C222.131 94.4317 217.202 98.2448 211.923 101.648C211.339 98.7787 211.047 95.8504 211.047 92.8055C211.779 92.2782 212.512 91.7361 213.237 91.1942L215.388 89.579C217.634 87.9055 219.847 86.1991 222.052 84.4843L224.255 82.7675C229.393 78.8113 234.576 74.8998 239.843 71.1122L242.106 69.496C247.449 65.694 252.793 62.027 258.215 58.4159L260.544 56.871C265.182 53.7598 269.878 50.7068 274.574 47.6542Z",
    fill: "#FFBC00",
    fillOpacity: 0.368627,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.835 55.2294C279.261 55.2294 295.819 71.7873 295.819 92.2128C295.819 112.638 279.261 129.196 258.835 129.196C238.41 129.196 221.852 112.638 221.852 92.2128C221.852 71.7873 238.41 55.2294 258.835 55.2294Z",
    fill: "#D07400",
    stroke: "#D07400",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.836 56.1689C278.742 56.1691 294.88 72.3064 294.88 92.2129C294.88 112.119 278.742 128.257 258.836 128.257C238.929 128.257 222.792 112.119 222.792 92.2129C222.792 72.3063 238.929 56.1689 258.836 56.1689Z",
    fill: "url(#paint2_linear_150_150)",
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.835 47.5367C283.786 47.5367 303.923 67.7318 303.923 92.6237C303.923 117.516 283.727 137.711 258.835 137.711C233.943 137.711 213.748 117.516 213.748 92.6237C213.748 67.7316 233.943 47.5368 258.835 47.5367ZM258.835 53.3268C237.337 53.3268 219.891 70.7726 219.891 92.2711C219.891 113.77 237.337 131.215 258.835 131.215C280.334 131.215 297.78 113.77 297.78 92.2711C297.779 70.7725 280.334 53.3268 258.835 53.3268Z",
    fill: "#FFA700",
    fillOpacity: 0.580392,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.835 52.7042C280.791 52.7042 298.579 70.4915 298.579 92.4474C298.579 114.403 280.791 132.192 258.835 132.192C236.879 132.191 219.092 114.403 219.092 92.4474C219.092 70.4915 236.88 52.7043 258.835 52.7042ZM258.835 53.3273C237.337 53.3274 219.891 70.773 219.891 92.2716C219.891 113.77 237.337 131.216 258.835 131.216C280.334 131.216 297.779 113.77 297.78 92.2716C297.78 70.7729 280.334 53.3273 258.835 53.3273Z",
    fill: "#FFA700",
    fillOpacity: 0.580392,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.487 92.8694L303.484 93.4924L299.514 93.468L299.517 92.845L303.487 92.8694Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.437 94.0388L303.414 94.6619L299.447 94.5144L299.469 93.8923L303.437 94.0388Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.397 95.4154L303.354 96.0375L299.393 95.767L299.436 95.1459L303.397 95.4154Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.263 96.8195L303.202 97.4396L299.252 97.048L299.312 96.4279L303.263 96.8195Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.124 98.2214L303.044 98.8386L299.107 98.324L299.188 97.7068L303.124 98.2214Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.917 99.5818L302.816 100.197L298.898 99.5583L298.999 98.9431L302.917 99.5818Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.729 100.963L302.609 101.575L298.712 100.816L298.831 100.203L302.729 100.963Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.446 102.283L302.307 102.89L298.436 102.009L298.575 101.4L302.446 102.283Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.117 103.688L301.958 104.291L298.117 103.287L298.275 102.684L302.117 103.688Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.765 105.024L301.588 105.623L297.781 104.499L297.956 103.901L301.765 105.024Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.323 106.351L301.127 106.943L297.356 105.699L297.551 105.108L301.323 106.351Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.922 107.669L300.708 108.256L296.978 106.895L297.191 106.309L300.922 107.669Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.411 108.955L300.179 109.533L296.494 108.056L296.726 107.478L300.411 108.955Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.892 110.263L299.641 110.834L296.004 109.241L296.254 108.671L299.892 110.263Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.298 111.497L299.031 112.059L295.444 110.354L295.713 109.791L299.298 111.497Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.723 112.76L298.438 113.314L294.908 111.498L295.193 110.943L298.723 112.76Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.066 114.022L297.763 114.567L294.292 112.64L294.594 112.095L298.066 114.022Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.356 115.201L297.037 115.737L293.626 113.702L293.947 113.167L297.356 115.201Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.631 116.379L296.295 116.904L292.951 114.765L293.286 114.24L296.631 116.379Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.851 117.574L295.499 118.087L292.223 115.845L292.574 115.331L295.851 117.574Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.081 118.732L294.713 119.235L291.507 116.892L291.876 116.389L295.081 118.732Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.271 119.806L293.888 120.298L290.757 117.858L291.14 117.366L294.271 119.806Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.391 120.96L292.992 121.439L289.938 118.902L290.337 118.423L293.391 120.96Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.517 121.981L292.104 122.447L289.13 119.817L289.543 119.35L292.517 121.981Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.526 123.016L291.099 123.468L288.208 120.746L288.636 120.293L291.526 123.016Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.62 124.024L290.18 124.464L287.375 121.655L287.815 121.213L290.62 124.024Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.572 124.996L289.118 125.422L286.4 122.527L286.855 122.099L289.572 124.996Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.61 125.931L288.142 126.343L285.517 123.365L285.984 122.953L288.61 125.931Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.534 126.897L287.054 127.294L284.523 124.236L285.003 123.838L287.534 126.897Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.473 127.741L285.981 128.124L283.547 124.989L284.038 124.607L286.473 127.741Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.355 128.553L284.852 128.921L282.515 125.711L283.018 125.344L285.355 128.553Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.198 129.375L283.683 129.727L281.448 126.446L281.962 126.095L284.198 129.375Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.054 130.174L282.53 130.509L280.397 127.159L280.922 126.825L283.054 130.174Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.893 130.92L281.358 131.239L279.33 127.825L279.866 127.505L281.893 130.92Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.663 131.611L280.118 131.913L278.198 128.437L278.744 128.135L280.663 131.611Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.417 132.245L278.863 132.529L277.053 128.995L277.608 128.711L279.417 132.245Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.215 132.911L277.651 133.177L275.954 129.588L276.519 129.322L278.215 132.911Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.924 133.487L276.353 133.736L274.768 130.096L275.339 129.847L276.924 133.487Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.622 133.998L275.043 134.229L273.574 130.539L274.153 130.31L275.622 133.998Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.349 134.544L273.764 134.756L272.409 131.024L272.995 130.811L274.349 134.544Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.051 134.985L272.459 135.18L271.224 131.406L271.815 131.212L273.051 134.985Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.713 135.423L271.114 135.599L269.999 131.788L270.598 131.613L271.713 135.423Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.359 135.816L269.755 135.973L268.759 132.129L269.363 131.972L270.359 135.816Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.003 136.134L268.394 136.271L267.52 132.398L268.129 132.26L269.003 136.134Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.653 136.445L267.041 136.562L266.289 132.664L266.902 132.546L267.653 136.445Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.297 136.693L265.682 136.792L265.051 132.872L265.667 132.773L266.297 136.693Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.895 136.89L264.277 136.969L263.77 133.031L264.388 132.952L264.895 136.89Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.534 137.024L262.913 137.083L262.531 133.132L263.151 133.073L263.534 137.024Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.124 137.155L261.502 137.197L261.24 133.235L261.861 133.194L262.124 137.155Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.773 137.23L260.151 137.251L260.011 133.283L260.634 133.262L260.773 137.23Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.361 137.299L258.738 137.301L258.721 133.331L259.344 133.329L259.361 137.299Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.092 133.281L257.988 137.251L257.365 137.234L257.469 133.266L258.092 133.281Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.808 133.269L256.583 137.233L255.96 137.198L256.186 133.234L256.808 133.269Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.524 133.151L255.175 137.104L254.555 137.051L254.903 133.097L255.524 133.151Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.282 133.056L253.81 136.998L253.192 136.924L253.663 132.983L254.282 133.056Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.017 132.878L252.422 136.804L251.806 136.711L252.402 132.785L253.017 132.878Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.775 132.648L251.058 136.554L250.445 136.441L251.162 132.536L251.775 132.648Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.534 132.461L249.695 136.342L249.086 136.21L249.925 132.33L250.534 132.461Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.306 132.184L248.344 136.037L247.74 135.886L248.7 132.033L249.306 132.184Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.075 131.864L246.995 135.685L246.395 135.516L247.475 131.695L248.075 131.864Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.833 131.465L245.632 135.25L245.038 135.06L246.238 131.276L246.833 131.465Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.635 131.11L244.316 134.856L243.729 134.648L245.048 130.903L245.635 131.11Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.437 130.659L243.002 134.36L242.421 134.135L243.856 130.434L244.437 130.659Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.279 130.214L241.727 133.869L241.154 133.625L242.704 129.971L243.279 130.214Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.129 129.724L240.464 133.329L239.9 133.067L241.564 129.463L242.129 129.724Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.98 129.154L239.204 132.704L238.646 132.426L240.422 128.875L240.98 129.154Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.82 128.563L237.931 132.055L237.382 131.759L239.271 128.266L239.82 128.563Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.716 127.966L236.719 131.397L236.18 131.084L238.177 127.651L238.716 127.966Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.675 127.321L235.572 130.689L235.045 130.36L237.146 126.991L237.675 127.321Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.563 126.613L234.357 129.914L233.84 129.568L236.046 126.268L236.563 126.613Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.5 125.917L233.193 129.148L232.685 128.785L234.993 125.555L235.5 125.917Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.505 125.175L232.098 128.333L231.602 127.955L234.009 124.796L234.505 125.175Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.491 124.411L230.987 127.492L230.503 127.099L233.006 124.018L233.491 124.411Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.515 123.57L229.917 126.573L229.446 126.165L232.044 123.163L232.515 123.57Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.552 122.747L228.863 125.667L228.406 125.245L231.094 122.324L231.552 122.747Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.631 121.925L227.852 124.76L227.406 124.323L230.186 121.489L230.631 121.925Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.739 121.035L226.873 123.784L226.44 123.334L229.307 120.585L229.739 121.035Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.862 120.084L225.911 122.742L225.494 122.278L228.445 119.621L228.862 120.084Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.027 119.14L224.996 121.704L224.594 121.229L227.625 118.664L228.027 119.14Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.209 118.134L224.1 120.603L223.713 120.115L226.822 117.646L227.209 118.134Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.452 117.181L223.266 119.554L222.894 119.054L226.079 116.681L226.452 117.181Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.698 116.125L222.442 118.398L222.085 117.887L225.341 115.615L225.698 116.125Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.958 115.074L221.633 117.243L221.293 116.721L224.618 114.553L224.958 115.074Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.275 114.011L220.884 116.077L220.56 115.543L223.952 113.48L224.275 114.011Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.615 112.971L220.16 114.927L219.853 114.385L223.308 112.428L223.615 112.971Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.044 111.835L219.53 113.682L219.24 113.131L222.754 111.283L223.044 111.835Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.423 110.738L218.853 112.476L218.58 111.915L222.15 110.178L222.423 110.738Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.901 109.551L218.278 111.177L218.023 110.608L221.645 108.982L221.901 109.551Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.38 108.385L217.707 109.895L217.471 109.318L221.143 107.809L221.38 108.385Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.87 107.23L217.152 108.623L216.935 108.039L220.652 106.646L220.87 107.23Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.477 106.046L216.717 107.323L216.516 106.733L220.276 105.456L220.477 106.046Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.07 104.812L216.272 105.97L216.09 105.374L219.888 104.216L220.07 104.812Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.734 103.636L215.902 104.676L215.738 104.075L219.57 103.035L219.734 103.636Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.387 102.417L215.524 103.335L215.379 102.729L219.242 101.811L219.387 102.417Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.085 101.133L215.195 101.929L215.07 101.318L218.96 100.522L219.085 101.133Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.856 99.9047L214.942 100.578L214.837 99.9633L218.751 99.2904L218.856 99.9047Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.684 98.6674L214.752 99.2181L214.666 98.601L218.598 98.0502L218.684 98.6674Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.502 97.3807L214.555 97.8094L214.488 97.1903L218.435 96.7616L218.502 97.3807Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.383 96.1527L214.424 96.4584L214.376 95.8363L218.334 95.5316L218.383 96.1527Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.259 94.8667L214.292 95.0503L214.263 94.4282L218.229 94.2446L218.259 94.8667Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.252 93.6388L214.282 93.7003L214.273 93.0773L218.243 93.0157L218.252 93.6388Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.255 91.7064L218.247 92.3304L214.277 92.2699L214.286 91.6469L218.255 91.7064Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.274 90.4153L218.246 91.0374L214.28 90.8547L214.308 90.2327L218.274 90.4153Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.346 89.1814L218.297 89.8025L214.339 89.4968L214.387 88.8757L218.346 89.1814Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.502 87.9191L218.435 88.5392L214.488 88.1115L214.554 87.4923L218.502 87.9191Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.638 86.6503L218.552 87.2675L214.62 86.7167L214.706 86.0995L218.638 86.6503Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.865 85.4352L218.757 86.0485L214.845 85.3746L214.951 84.7614L218.865 85.4352Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.11 84.1885L218.986 84.7998L215.095 84.0049L215.22 83.3936L219.11 84.1885Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.407 82.9635L219.263 83.5699L215.4 82.652L215.544 82.0455L219.407 82.9635Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.732 81.7122L219.57 82.3137L215.738 81.2756L215.901 80.6731L219.732 81.7122Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.073 80.5034L219.891 81.0991L216.093 79.9409L216.275 79.3452L220.073 80.5034Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.45 79.2958L220.25 79.8856L216.49 78.6083L216.69 78.0184L220.45 79.2958Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.908 78.0853L220.689 78.6683L216.972 77.2748L217.19 76.6918L220.908 78.0853Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.381 76.9302L221.144 77.5073L217.472 75.9966L217.709 75.4204L221.381 76.9302Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.882 75.7675L221.626 76.3358L218.004 74.7108L218.259 74.1425L221.882 75.7675Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.463 74.6058L222.189 75.1674L218.62 73.4291L218.893 72.8685L222.463 74.6058Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.998 73.4753L222.708 74.0271L219.194 72.1785L219.484 71.6267L222.998 73.4753Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.614 72.3605L223.306 72.9034L219.852 70.9445L220.159 70.4025L223.614 72.3605Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.277 71.2993L223.953 71.8315L220.562 69.7681L220.885 69.2358L224.277 71.2993Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.964 70.2545L224.624 70.776L221.299 68.6071L221.639 68.0856L224.964 70.2545Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.681 69.1835L225.324 69.6952L222.069 67.4227L222.425 66.912L225.681 69.1835Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.441 68.1788L226.068 68.6788L222.883 66.3058L223.256 65.8058L226.441 68.1788Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.223 67.176L226.837 67.6643L223.727 65.1956L224.115 64.7073L227.223 67.176Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 66.1981L227.597 66.6737L224.566 64.1093L224.968 63.6337L228 66.1981Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.849 65.2426L228.433 65.7054L225.482 63.0482L225.899 62.5853L228.849 65.2426Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.766 64.3259L229.334 64.7751L226.468 62.0281L226.9 61.5769L229.766 64.3259Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.631 63.3898L230.185 63.8253L227.406 60.9904L227.851 60.5538L230.631 63.3898Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.565 62.5642L231.106 62.9861L228.417 60.0662L228.874 59.6443L231.565 62.5642Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.524 61.7291L232.054 62.1373L229.455 59.1344L229.926 58.7272L232.524 61.7291Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.469 60.9127L232.985 61.3053L230.482 58.2242L230.965 57.8317L233.469 60.9127Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.482 60.1282L233.986 60.5071L231.577 57.3489L232.073 56.97L234.482 60.1282Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.512 59.4152L235.005 59.7775L232.696 56.547L233.204 56.1837L235.512 59.4152Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.576 58.6798L236.057 59.0265L233.852 55.7247L234.371 55.379L236.576 58.6798Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.651 58.019L237.123 58.3481L235.021 54.98L235.55 54.6509L237.651 58.019Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.712 57.3695L238.173 57.682L236.177 54.2504L236.716 53.9359L238.712 57.3695Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.838 56.751L239.29 57.0469L237.401 53.5547L237.95 53.2578L239.838 56.751Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.943 56.1553L240.386 56.4336L238.609 52.8838L239.167 52.6045L240.943 56.1553Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.143 55.642L241.577 55.9037L239.913 52.2982L240.478 52.0375L242.143 55.642Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.251 55.1063L242.677 55.3505L241.126 51.6952L241.699 51.452L243.251 55.1063Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.438 54.6672L243.858 54.8928L242.421 51.1907L243.002 50.9661L244.438 54.6672Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.669 54.2129L245.08 54.4199L243.761 50.6758L244.349 50.4678L245.669 54.2129Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.853 53.8401L246.259 54.0286L245.058 50.2434L245.652 50.0549L246.853 53.8401Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.072 53.4552L247.473 53.6241L246.393 49.8038L246.992 49.6349L248.072 53.4552Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.308 53.124L248.704 53.2754L247.743 49.4229L248.347 49.2715L249.308 53.124Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.542 52.8561L249.933 52.9879L249.094 49.1071L249.703 48.9752L250.542 52.8561Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.782 52.65L251.169 52.7623L250.453 48.8571L251.066 48.7448L251.782 52.65Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.01 52.4363L252.395 52.53L251.799 48.6042L252.416 48.5105L253.01 52.4363Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.3 52.2716L253.681 52.3458L253.21 48.4034L253.828 48.3302L254.3 52.2716Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.532 52.177L254.912 52.2307L254.564 48.2756L255.184 48.2219L255.532 52.177Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.825 52.0718L256.203 52.1069L255.976 48.1431L256.598 48.1079L256.825 52.0718Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.056 52.0271L257.433 52.0427L257.33 48.074L257.953 48.0583L258.056 52.0271Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.353 48.0111L259.336 51.9808L258.713 51.9789L258.73 48.0092L259.353 48.0111Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.769 48.0939L260.629 52.0616L260.007 52.0402L260.146 48.0724L260.769 48.0939Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.15 48.1545L261.888 52.1165L261.267 52.0745L261.528 48.1135L262.15 48.1545Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.556 48.2467L263.173 52.1979L262.553 52.1383L262.935 48.1871L263.556 48.2467Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.894 48.4453L264.387 52.3828L263.769 52.3037L264.276 48.3662L264.894 48.4453Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.263 48.6677L265.633 52.5886L265.017 52.489L265.648 48.5681L266.263 48.6677Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.638 48.8821L266.886 52.7805L266.274 52.6624L267.026 48.7639L267.638 48.8821Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.015 49.1925L268.141 53.0656L267.533 52.9279L268.407 49.0548L269.015 49.1925Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.357 49.5203L269.361 53.364L268.758 53.2068L269.754 49.363L270.357 49.5203Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.686 49.8971L270.572 53.7076L269.973 53.5328L271.088 49.7223L271.686 49.8971Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.022 50.3602L271.788 54.1337L271.195 53.9393L272.429 50.1659L273.022 50.3602Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.338 50.7786L272.983 54.511L272.397 54.2981L273.752 50.5657L274.338 50.7786Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.675 51.3147L274.206 55.0032L273.627 54.7727L275.095 51.0842L275.675 51.3147Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.925 51.8352L275.34 55.4758L274.768 55.2258L276.353 51.5862L276.925 51.8352Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.231 52.4193L276.532 56.0072L275.969 55.7416L277.668 52.1527L278.231 52.4193Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.458 53.0548L277.649 56.589L277.094 56.3048L278.903 52.7706L279.458 53.0548Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.66 53.6991L278.741 57.1747L278.195 56.8739L280.114 53.3973L280.66 53.6991Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.909 54.4073L279.882 57.8224L279.346 57.5031L281.374 54.089L281.909 54.4073Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.037 55.1353L280.904 58.4839L280.38 58.1499L282.511 54.8003L283.037 55.1353Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.23 55.9244L281.993 59.2057L281.479 58.8541L283.714 55.5739L284.23 55.9244Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.337 56.7552L283 59.9652L282.496 59.598L284.834 56.3881L285.337 56.7552Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.461 57.6202L284.024 60.755L283.532 60.3722L285.969 57.2374L286.461 57.6202Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.548 58.4755L285.016 61.5331L284.537 61.1366L287.068 58.078L287.548 58.4755Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.556 59.3658L285.931 62.3444L285.464 61.9323L288.09 58.9537L288.556 59.3658Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.619 60.333L286.901 63.2285L286.447 62.8008L289.164 59.9053L289.619 60.333Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.581 61.2881L287.775 64.0986L287.335 63.6572L290.14 60.8477L290.581 61.2881Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.565 62.3188L288.676 65.0405L288.249 64.5874L291.139 61.8638L291.565 62.3188Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.463 63.326L289.489 65.9569L289.076 65.4901L292.05 62.8593L292.463 63.326Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.365 64.3751L290.313 66.9122L289.914 66.4337L292.968 63.8956L293.365 64.3751Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.237 65.4827L291.106 67.925L290.724 67.4329L293.854 64.9915L294.237 65.4827Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.077 66.5929L291.872 68.9347L291.502 68.4318L294.708 66.089L295.077 66.5929Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.895 67.7554L292.618 69.9976L292.266 69.4829L295.542 67.2417L295.895 67.7554Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.628 68.9447L293.283 71.0844L292.948 70.5599L296.292 68.4203L296.628 68.9447Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.346 70.1198L293.937 72.1549L293.616 71.6198L297.025 69.5846L297.346 70.1198Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.085 71.3259L294.613 73.2527L294.31 72.7078L297.782 70.781L298.085 71.3259Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.696 72.5793L295.166 74.3958L294.881 73.8411L298.411 72.0247L298.696 72.5793Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.296 73.8221L295.711 75.5272L295.442 74.9657L299.027 73.2577L299.296 73.8221Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.879 75.0447L296.243 76.6375L295.993 76.0662L299.629 74.4744L299.879 75.0447Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.426 76.3323L296.74 77.8088L296.509 77.2297L300.195 75.7542L300.426 76.3323Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.904 77.63L297.174 78.9904L296.96 78.4044L300.69 77.0441L300.904 77.63Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.337 78.9907L297.567 80.2339L297.372 79.6421L301.142 78.3989L301.337 78.9907Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.745 80.2787L297.939 81.4037L297.762 80.806L301.57 79.681L301.745 80.2787Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.117 81.6445L298.275 82.6475L298.117 82.0439L301.958 81.04L302.117 81.6445Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.407 83.0002L298.536 83.8821L298.397 83.2747L302.269 82.3928L302.407 83.0002Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.706 84.3551L298.809 85.1139L298.69 84.5026L302.588 83.7428L302.706 84.3551Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.952 85.7692L299.034 86.4088L298.932 85.7936L302.851 85.1539L302.952 85.7692Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.125 87.1272L299.188 87.6418L299.108 87.0237L303.044 86.51L303.125 87.1272Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.301 88.5363L299.35 88.9288L299.289 88.3087L303.239 87.9171L303.301 88.5363Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.41 89.8896L299.448 90.1592L299.406 89.5371L303.367 89.2686L303.41 89.8896Z",
    fill: "#FFBC00",
    fillOpacity: 0.082353,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.462 91.3031L299.494 91.4506L299.472 90.8275L303.439 90.681L303.462 91.3031Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.457 92.483L299.486 92.5084L299.483 91.8844L303.453 91.86L303.457 92.483Z",
    fill: "#FFBC00",
    fillOpacity: 0.290196,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.044 47.7727C278.089 48.8857 281.018 50.2911 283.771 51.9885C283.015 52.5126 282.257 53.0359 281.442 53.5598C278.631 51.9206 275.587 50.5734 272.425 49.5764C272.859 49.2864 273.294 48.9829 273.729 48.679C274.167 48.372 274.606 48.065 275.044 47.7727Z",
    fill: "#FFBC00",
    fillOpacity: 0.368627,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.417 125.287C232.991 130.682 240.028 134.672 247.829 136.612C247.073 137.251 246.317 137.833 245.502 138.472C237.819 136.242 230.955 132.196 225.44 126.742C226.137 126.219 226.777 125.752 227.417 125.287Z",
    fill: "#FFBC00",
    fillOpacity: 0.368627,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.011 55.9923C278.383 55.9344 294.677 71.9966 294.88 91.3292C294.732 87.2193 293.91 83.1264 292.414 79.2863L292.083 78.4669C285.722 63.0283 269.23 53.965 252.803 56.8234L252.021 56.9679C235.962 59.9755 223.796 73.9473 222.83 90.1974C223.688 71.5038 239.346 56.3173 258.089 55.9962L259.011 55.9923Z",
    fill: "#FBF9D5",
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.07 47.243C283.48 47.1271 303.939 67.4544 304.101 91.7675C303.947 86.5619 302.919 81.3343 301.013 76.4921L300.597 75.4725C292.561 56.1032 271.831 44.702 251.24 48.2723L250.26 48.453C230.092 52.2025 214.815 69.7989 213.675 90.1874C214.732 66.4977 234.668 47.3251 258.49 47.2411L259.07 47.243Z",
    fill: "#FBF9D5",
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.88 92.8828C294.698 112.232 278.395 128.315 259.011 128.257L258.089 128.256C239.342 127.989 223.681 112.797 222.829 94.0977C223.777 110.039 235.567 123.877 251.189 127.185L251.962 127.34C268.384 130.52 285.033 121.747 291.769 106.512L292.083 105.781C293.794 101.695 294.726 97.2985 294.88 92.8828Z",
    fill: "#FBF9D5",
    fillOpacity: 0.411765,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.101 93.3606C303.941 117.482 283.803 137.681 259.648 137.886L259.07 137.887C234.992 138.172 214.739 118.826 213.675 94.9944C214.796 115.002 229.601 132.357 249.286 136.484L250.26 136.676C270.844 140.724 291.768 129.688 300.205 110.573L300.597 109.657C302.769 104.533 303.936 98.9343 304.101 93.3606Z",
    fill: "#FFA700",
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.75 89.954C218.771 90.1601 218.801 90.455 218.839 90.8094C218.913 91.5186 219.014 92.467 219.121 93.4247C219.227 94.3826 219.339 95.3505 219.435 96.0966C219.483 96.4691 219.527 96.7867 219.565 97.0204C219.584 97.1373 219.602 97.2341 219.617 97.3055C219.625 97.3409 219.632 97.3704 219.638 97.3934C219.645 97.4163 219.652 97.4346 219.658 97.4452V97.4442C219.663 97.4569 219.671 97.467 219.682 97.4725C219.694 97.478 219.708 97.4785 219.723 97.4764C219.754 97.4723 219.794 97.4552 219.841 97.4286C219.935 97.3751 220.062 97.28 220.211 97.1561C220.508 96.9081 220.894 96.5442 221.276 96.1698C221.567 95.8843 221.855 95.5916 222.101 95.3397C221.895 95.5688 221.662 95.8327 221.435 96.1034C221.112 96.4888 220.8 96.8876 220.591 97.2157C220.486 97.3796 220.406 97.5262 220.364 97.6454C220.343 97.705 220.331 97.7583 220.33 97.8036C220.329 97.8263 220.332 97.8472 220.338 97.8661L220.364 97.9159V97.9169C220.388 97.9408 220.432 97.9632 220.492 97.9852C220.552 98.0073 220.629 98.029 220.72 98.0507C220.904 98.0941 221.147 98.1373 221.427 98.1786C221.989 98.2612 222.705 98.3381 223.41 98.4042C224.115 98.4703 224.808 98.5258 225.326 98.5643C225.585 98.5836 225.8 98.5989 225.95 98.6093C225.957 98.6097 225.963 98.6098 225.969 98.6102C225.838 98.6154 225.653 98.6233 225.429 98.6327C224.971 98.652 224.35 98.6787 223.704 98.7118C223.058 98.7448 222.386 98.7838 221.825 98.8251C221.264 98.8663 220.812 98.9107 220.605 98.955C220.399 98.9991 220.285 99.0582 220.233 99.1249C220.207 99.1586 220.196 99.194 220.197 99.2294C220.198 99.2644 220.211 99.2988 220.23 99.3309C220.268 99.3952 220.332 99.4535 220.385 99.495C220.412 99.5159 220.437 99.5331 220.455 99.5448C220.464 99.5506 220.471 99.5554 220.476 99.5585C220.478 99.5596 220.48 99.5597 220.481 99.5604L223.473 103.117C223.468 103.112 223.463 103.107 223.458 103.102C223.361 103.012 223.221 102.882 223.052 102.725C222.716 102.413 222.263 101.993 221.797 101.563C221.331 101.134 220.852 100.695 220.464 100.346C220.27 100.171 220.098 100.018 219.963 99.9003L219.675 99.661H219.674C219.656 99.6502 219.638 99.6475 219.621 99.6542C219.604 99.6606 219.589 99.6755 219.575 99.6952C219.548 99.7345 219.522 99.7995 219.499 99.8856C219.452 100.059 219.412 100.323 219.376 100.646C219.304 101.294 219.252 102.184 219.216 103.083C219.179 103.982 219.157 104.891 219.144 105.574C219.139 105.846 219.136 106.083 219.134 106.269C219.128 106.117 219.12 105.93 219.112 105.718C219.088 105.115 219.055 104.305 219.018 103.479C218.982 102.654 218.942 101.811 218.903 101.142C218.884 100.808 218.864 100.517 218.846 100.293C218.838 100.181 218.829 100.085 218.821 100.01L218.798 99.8436V99.8427L218.785 99.8202C218.78 99.8139 218.775 99.8081 218.768 99.8036C218.755 99.7945 218.739 99.7894 218.721 99.788C218.686 99.7852 218.64 99.7962 218.588 99.8173C218.483 99.8596 218.343 99.9458 218.182 100.061C217.86 100.293 217.447 100.646 217.04 101.013C216.632 101.38 216.23 101.762 215.929 102.052C215.819 102.158 215.722 102.252 215.644 102.329C215.716 102.247 215.805 102.145 215.906 102.028C216.18 101.711 216.546 101.285 216.909 100.852C217.272 100.419 217.634 99.9787 217.901 99.6317C218.035 99.4583 218.145 99.3076 218.219 99.1932C218.257 99.1361 218.286 99.0877 218.304 99.0497C218.314 99.0307 218.321 99.014 218.325 98.9999L218.328 98.9628L218.327 98.9608L218.295 98.9344C218.28 98.9277 218.26 98.9215 218.236 98.9159C218.188 98.9045 218.12 98.8946 218.037 98.8866C217.871 98.8705 217.641 98.8609 217.369 98.8553C216.824 98.8443 216.107 98.8514 215.395 98.8661C214.683 98.8808 213.974 98.9034 213.444 98.9218C213.179 98.9309 212.959 98.9392 212.804 98.9452C212.79 98.9458 212.776 98.9456 212.762 98.9462C212.77 98.945 212.778 98.9444 212.786 98.9432C212.927 98.9218 213.13 98.8914 213.373 98.8534C213.859 98.7772 214.509 98.6723 215.163 98.5585C215.816 98.4447 216.473 98.3218 216.974 98.2089C217.225 98.1525 217.437 98.0988 217.59 98.0497C217.666 98.0252 217.728 98.0014 217.773 97.9794C217.796 97.9683 217.815 97.9578 217.829 97.9471L217.858 97.913C217.863 97.9006 217.862 97.8839 217.858 97.8661C217.854 97.8479 217.847 97.8257 217.836 97.8007C217.814 97.7503 217.778 97.6859 217.731 97.6093C217.638 97.4555 217.499 97.2519 217.328 97.0165C216.986 96.5456 216.52 95.9453 216.051 95.3544C215.581 94.7634 215.107 94.1819 214.751 93.7479C214.632 93.6034 214.526 93.4757 214.438 93.369C214.54 93.4794 214.664 93.6136 214.804 93.7655C215.205 94.1986 215.743 94.775 216.29 95.3475C216.837 95.92 217.393 96.4886 217.831 96.9071C218.05 97.1163 218.239 97.2883 218.384 97.4042C218.456 97.4621 218.516 97.5071 218.564 97.535C218.588 97.5489 218.609 97.5586 218.627 97.5643C218.635 97.5672 218.644 97.5687 218.652 97.5692L218.674 97.5673C218.681 97.5645 218.686 97.5589 218.691 97.5526C218.696 97.5461 218.702 97.5378 218.706 97.5282C218.714 97.509 218.722 97.4822 218.729 97.4501C218.744 97.3858 218.757 97.2956 218.767 97.1835C218.789 96.9583 218.804 96.6428 218.813 96.2684C218.833 95.5196 218.831 94.5322 218.82 93.5487C218.809 92.565 218.789 91.5845 218.771 90.8505C218.763 90.4838 218.755 90.1785 218.749 89.9647C218.749 89.9552 218.748 89.9455 218.748 89.9364C218.748 89.9421 218.749 89.9481 218.75 89.954Z",
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.933 112.728C284.991 113.306 285.069 114.08 285.154 114.866C285.238 115.651 285.329 116.448 285.409 117.07C285.449 117.381 285.486 117.649 285.519 117.85C285.535 117.95 285.551 118.034 285.565 118.098C285.579 118.162 285.591 118.208 285.603 118.232V118.231C285.608 118.242 285.616 118.251 285.626 118.256C285.637 118.261 285.649 118.262 285.663 118.26C285.689 118.257 285.724 118.243 285.763 118.222C285.843 118.179 285.95 118.102 286.074 118.001C286.322 117.8 286.641 117.504 286.957 117.2C287.161 117.002 287.364 116.8 287.544 116.619C287.397 116.782 287.236 116.963 287.08 117.148C286.812 117.463 286.553 117.791 286.379 118.061C286.293 118.196 286.226 118.317 286.191 118.416C286.173 118.466 286.163 118.511 286.163 118.549C286.162 118.568 286.165 118.586 286.169 118.602L286.192 118.645V118.646C286.212 118.666 286.249 118.685 286.298 118.703C286.348 118.722 286.412 118.74 286.487 118.758C286.637 118.794 286.836 118.83 287.066 118.865C287.526 118.933 288.112 118.997 288.688 119.052C289.264 119.107 289.831 119.154 290.254 119.186C290.45 119.201 290.614 119.212 290.735 119.22C290.632 119.224 290.497 119.229 290.339 119.235C289.965 119.249 289.459 119.269 288.93 119.294C288.402 119.32 287.851 119.351 287.388 119.387C287.042 119.414 286.744 119.443 286.542 119.475L286.374 119.507C286.198 119.537 286.099 119.582 286.052 119.634C286.029 119.661 286.018 119.689 286.018 119.718C286.018 119.747 286.028 119.776 286.043 119.803C286.074 119.856 286.127 119.905 286.171 119.94C286.194 119.957 286.214 119.972 286.229 119.982C286.236 119.987 286.242 119.991 286.247 119.994C286.248 119.994 286.249 119.995 286.25 119.995L288.657 122.907C288.578 122.833 288.468 122.731 288.336 122.608C288.061 122.351 287.691 122.006 287.309 121.654C286.927 121.301 286.535 120.941 286.215 120.655C286.056 120.512 285.914 120.387 285.801 120.29L285.561 120.096C285.547 120.087 285.532 120.085 285.518 120.091C285.505 120.097 285.492 120.109 285.482 120.125C285.461 120.158 285.442 120.212 285.424 120.283C285.389 120.425 285.358 120.64 285.331 120.905C285.275 121.434 285.235 122.161 285.206 122.895C285.176 123.629 285.158 124.37 285.147 124.928C285.143 125.108 285.14 125.268 285.138 125.404C285.134 125.296 285.131 125.173 285.125 125.036C285.107 124.54 285.081 123.874 285.051 123.196C285.022 122.517 284.99 121.825 284.957 121.277C284.94 121.003 284.923 120.765 284.907 120.582C284.899 120.492 284.891 120.414 284.883 120.353L284.861 120.22C284.857 120.204 284.849 120.191 284.839 120.18C284.829 120.17 284.817 120.162 284.802 120.159C284.773 120.151 284.736 120.156 284.694 120.17C284.609 120.198 284.494 120.264 284.362 120.355C284.097 120.537 283.755 120.823 283.417 121.124C283.08 121.425 282.746 121.741 282.497 121.982C282.444 122.033 282.395 122.08 282.35 122.123C282.39 122.079 282.435 122.031 282.482 121.978C282.712 121.721 283.019 121.375 283.324 121.023C283.628 120.671 283.932 120.311 284.155 120.025C284.266 119.882 284.358 119.756 284.42 119.66C284.451 119.611 284.475 119.57 284.49 119.536C284.497 119.52 284.503 119.504 284.506 119.492C284.509 119.479 284.511 119.466 284.508 119.456C284.505 119.445 284.496 119.436 284.485 119.429C284.473 119.422 284.457 119.416 284.438 119.411C284.4 119.399 284.346 119.389 284.28 119.381C284.147 119.365 283.96 119.355 283.739 119.349C283.295 119.338 282.709 119.346 282.125 119.361C281.542 119.375 280.961 119.397 280.525 119.415C280.314 119.424 280.137 119.432 280.01 119.438C280.124 119.42 280.28 119.396 280.463 119.367C280.862 119.302 281.394 119.214 281.93 119.119C282.466 119.023 283.005 118.92 283.418 118.827C283.625 118.78 283.8 118.735 283.927 118.695C283.991 118.675 284.043 118.656 284.082 118.638C284.1 118.629 284.116 118.62 284.128 118.612L284.155 118.584C284.16 118.574 284.16 118.559 284.158 118.544C284.155 118.529 284.149 118.511 284.14 118.491C284.123 118.45 284.095 118.397 284.057 118.334C283.981 118.209 283.867 118.042 283.726 117.849C283.445 117.463 283.059 116.971 282.67 116.487C282.281 116.002 281.889 115.525 281.593 115.169C281.533 115.096 281.476 115.028 281.424 114.966C281.486 115.033 281.553 115.108 281.627 115.188C281.956 115.544 282.396 116.018 282.844 116.488C283.292 116.957 283.748 117.424 284.106 117.765C284.285 117.936 284.44 118.076 284.557 118.169C284.616 118.216 284.666 118.251 284.705 118.273C284.724 118.284 284.742 118.292 284.756 118.296C284.77 118.3 284.784 118.301 284.795 118.295V118.296C284.808 118.291 284.818 118.277 284.827 118.261C284.835 118.245 284.844 118.223 284.851 118.196C284.866 118.142 284.878 118.066 284.889 117.973C284.911 117.786 284.925 117.526 284.935 117.217C284.954 116.6 284.953 115.789 284.942 114.982C284.931 114.174 284.91 113.371 284.893 112.769C284.886 112.513 284.878 112.293 284.873 112.125C284.888 112.284 284.909 112.489 284.933 112.728Z",
    fill: "url(#paint3_radial_150_150)",
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.535 47.8507C287.569 48.1695 287.618 48.6255 287.677 49.174C287.797 50.2713 287.958 51.74 288.126 53.2228C288.295 54.7053 288.472 56.2025 288.621 57.3585C288.695 57.9366 288.763 58.4301 288.819 58.7931C288.847 58.9744 288.872 59.1234 288.894 59.2345C288.905 59.2899 288.915 59.3362 288.924 59.3722C288.934 59.408 288.942 59.4354 288.95 59.4513V59.4503C288.956 59.4678 288.969 59.4798 288.986 59.4855C289.002 59.4909 289.023 59.4896 289.045 59.4845C289.091 59.4742 289.152 59.4458 289.224 59.4015C289.369 59.3127 289.565 59.1594 289.794 58.964C290.254 58.5729 290.851 58.0076 291.442 57.4279C291.94 56.9394 292.432 56.4394 292.837 56.0255C292.485 56.4103 292.07 56.8717 291.667 57.3468C291.161 57.945 290.672 58.5636 290.347 59.0734C290.185 59.3282 290.063 59.5572 290 59.7423C289.968 59.8346 289.951 59.9167 289.952 59.9865C289.952 60.0561 289.97 60.1144 290.008 60.1573V60.1583C290.043 60.1971 290.11 60.2344 290.201 60.2706C290.292 60.307 290.411 60.3427 290.552 60.3781C290.835 60.4488 291.208 60.518 291.642 60.5841C292.509 60.7163 293.616 60.8368 294.707 60.9396C295.797 61.0424 296.87 61.1269 297.671 61.1857C298.072 61.215 298.404 61.2384 298.636 61.254C298.698 61.2582 298.752 61.2607 298.799 61.2638C298.764 61.2655 298.725 61.2685 298.681 61.2706C298.476 61.2807 298.182 61.2952 297.825 61.3136C297.111 61.3503 296.146 61.4014 295.14 61.4601C293.381 61.5628 291.496 61.6885 290.62 61.797L290.309 61.8419C289.986 61.9007 289.81 61.9863 289.73 62.0831C289.69 62.132 289.674 62.1843 289.676 62.2365C289.679 62.2882 289.699 62.3393 289.729 62.3878C289.789 62.4849 289.889 62.5744 289.973 62.6388C290.016 62.6711 290.055 62.6977 290.083 62.7159C290.097 62.7249 290.109 62.7317 290.117 62.7365C290.121 62.7388 290.123 62.7411 290.125 62.7423H290.126L294.816 68.3468C294.789 68.3213 294.758 68.2929 294.724 68.2609C294.575 68.1202 294.361 67.9181 294.102 67.6749C293.585 67.1886 292.888 66.5352 292.168 65.8673C291.449 65.1994 290.708 64.5169 290.102 63.9718C289.497 63.4271 289.026 63.0185 288.849 62.9005H288.848C288.826 62.8847 288.803 62.8806 288.78 62.8898C288.757 62.8988 288.737 62.9199 288.718 62.9493C288.681 63.0086 288.646 63.1089 288.614 63.2423C288.549 63.5097 288.491 63.9171 288.44 64.4181C288.338 65.4204 288.263 66.8009 288.208 68.1954C288.152 69.59 288.117 70.9991 288.096 72.0597C288.086 72.5795 288.079 73.0157 288.075 73.3253C288.066 73.0602 288.056 72.7025 288.042 72.2794C288.01 71.3426 287.966 70.0848 287.915 68.8038C287.863 67.523 287.804 66.2179 287.744 65.1857C287.713 64.6698 287.682 64.2219 287.652 63.879C287.637 63.7075 287.622 63.5618 287.607 63.4474C287.599 63.3906 287.592 63.3412 287.584 63.2999L287.562 63.2003C287.554 63.1747 287.54 63.1544 287.522 63.1398C287.504 63.1253 287.481 63.1165 287.456 63.1134C287.404 63.1073 287.336 63.1224 287.257 63.1534C287.099 63.2158 286.885 63.3469 286.637 63.5245C286.141 63.88 285.503 64.4255 284.872 64.9943C284.24 65.5633 283.616 66.156 283.15 66.6066C282.942 66.8073 282.765 66.9789 282.633 67.1085C282.756 66.9702 282.922 66.7852 283.115 66.5665C283.548 66.0756 284.124 65.4168 284.697 64.7452C285.269 64.0737 285.838 63.3892 286.256 62.8468C286.466 62.5756 286.638 62.3394 286.753 62.1583C286.811 62.0679 286.855 61.9909 286.883 61.9298C286.897 61.8994 286.907 61.8724 286.913 61.8497L286.916 61.7911C286.91 61.774 286.895 61.7598 286.875 61.7482C286.853 61.7363 286.824 61.7258 286.789 61.7159C286.717 61.6961 286.615 61.6792 286.489 61.6652C286.236 61.637 285.882 61.6191 285.46 61.6095C284.618 61.5902 283.506 61.6033 282.398 61.629C281.29 61.6547 280.185 61.6936 279.357 61.7257C278.943 61.7418 278.598 61.7563 278.357 61.7667C278.296 61.7694 278.241 61.7705 278.194 61.7726C278.233 61.7668 278.277 61.7613 278.325 61.754C278.543 61.721 278.856 61.674 279.232 61.6154C279.984 61.4979 280.99 61.3355 282.003 61.1593C283.016 60.9831 284.037 60.7926 284.819 60.6163C285.21 60.5282 285.541 60.4435 285.783 60.3663C285.903 60.3278 286.002 60.2907 286.074 60.256C286.11 60.2386 286.14 60.2217 286.163 60.2052C286.185 60.1889 286.201 60.1723 286.209 60.1554L286.21 60.1564C286.22 60.1401 286.22 60.1171 286.215 60.0909C286.211 60.0644 286.201 60.0317 286.185 59.9943C286.154 59.9189 286.101 59.8202 286.03 59.7032C285.888 59.4693 285.674 59.1578 285.41 58.796C284.881 58.0719 284.153 57.1445 283.419 56.2306C282.685 55.3168 281.944 54.4158 281.386 53.7433C281.181 53.4955 281 53.2786 280.854 53.1036C281.018 53.2854 281.224 53.5142 281.462 53.7755C282.081 54.4545 282.911 55.3575 283.755 56.2531C284.599 57.1485 285.458 58.0369 286.135 58.6866C286.474 59.0115 286.768 59.2773 286.992 59.4542C287.103 59.5424 287.198 59.6087 287.272 59.6495C287.309 59.6698 287.341 59.6843 287.369 59.6915C287.382 59.6951 287.395 59.6974 287.407 59.6974L287.438 59.6906C287.456 59.6813 287.472 59.659 287.485 59.629C287.498 59.5983 287.511 59.557 287.523 59.506C287.546 59.4038 287.566 59.2609 287.583 59.0841C287.616 58.7304 287.638 58.238 287.652 57.6544C287.679 56.4871 287.672 54.9526 287.65 53.4259C287.628 51.8992 287.591 50.38 287.56 49.2423C287.544 48.6734 287.53 48.1995 287.52 47.8683C287.518 47.7885 287.515 47.717 287.513 47.6544C287.519 47.7124 287.527 47.7779 287.535 47.8507Z",
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.666 93.7684C253.013 93.8015 255.362 94.2459 257.232 95.1014L257.6 95.2782C258.329 95.6459 258.865 95.9325 259.453 96.2948L260.067 96.6884C260.221 96.7905 260.301 96.8492 260.376 96.911L260.649 97.1522C260.756 97.2456 260.831 97.3032 260.907 97.3612L261.17 97.576C262.464 98.7291 263.086 99.3667 263.937 100.645L264.319 101.235C266.488 104.679 266.748 107.315 266.749 111.472H234.169V108.652C234.169 107.37 234.486 106.154 234.854 104.991L235.229 103.847C235.314 103.59 235.397 103.386 235.491 103.185L235.809 102.542C236.148 101.863 236.494 101.288 236.886 100.721L237.296 100.152C238.004 99.2049 238.83 98.3161 239.733 97.5438L240.125 97.2196C241.131 96.4164 241.757 96.033 242.684 95.5731L243.737 95.0692C245.658 94.1663 248.161 93.7332 250.666 93.7684Z",
    fill: "#D07400",
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.527 90.7372C277.472 90.7372 281.728 92.5821 284.723 96.4188L285.009 96.7958C285.393 97.3186 285.735 97.8599 286.049 98.4305L286.355 99.0126C287.355 101.004 287.686 102.715 287.789 104.526L287.821 105.31V108.641H269.812C269.809 106.182 268.791 102.82 267.617 100.688L267.38 100.279C267.111 99.837 266.881 99.4287 266.61 99.0204L266.322 98.6102C266.006 98.189 265.674 97.69 265.323 97.2977L265.172 97.1366C264.982 96.945 264.83 96.8153 264.671 96.6376L264.508 96.4393C264.315 96.1871 263.869 95.7952 263.441 95.4198C263.226 95.2319 263.016 95.0476 262.843 94.8866C262.675 94.73 262.543 94.5961 262.478 94.5018L265.579 92.3778L265.578 92.3768C267.36 91.3722 270.092 90.7372 272.527 90.7372Z",
    fill: "#D07400",
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.25 70.7452C248.831 69.4581 251.612 69.4594 254.188 70.5782L254.7 70.8165C256.851 71.8863 258.165 73.4545 259.178 75.4698L259.377 75.879C260.597 78.4742 260.465 81.4145 259.521 84.0323L259.322 84.5519C258.494 86.5771 256.812 88.3305 254.908 89.3947L254.526 89.5988C252.804 90.4641 250.85 90.7782 248.787 90.42L248.373 90.339C246.627 89.9618 244.898 88.9356 243.677 87.7062H243.676L242.551 86.3165C241.028 84.1648 240.668 82.2028 240.668 79.6134L240.672 79.3575C240.753 76.8795 241.99 74.5031 243.258 73.1075L243.521 72.8331C244.271 72.0898 244.924 71.4849 245.84 70.964L246.25 70.7452Z",
    fill: "#D07400",
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.174 72.0729C271.504 70.9327 274.428 70.9398 276.666 72.2965L276.881 72.4313C277.339 72.7325 277.552 72.862 277.763 73.026C277.868 73.1079 277.972 73.1988 278.106 73.3239L278.625 73.8287C280.08 75.2689 280.917 77.3215 281.091 79.4235C281.255 81.3944 280.836 83.4082 279.801 85.0006L279.586 85.3131C278.628 86.6293 277.662 87.56 276.511 88.1617C275.359 88.7635 274.021 89.0367 272.317 89.0367L271.952 89.027C268.331 88.8278 265.273 85.6899 264.53 82.2643L264.463 81.9205C264.166 80.1795 264.24 78.8067 264.632 77.5533C264.975 76.4565 265.562 75.4501 266.356 74.3678L266.708 73.8981C266.956 73.5767 267.387 73.2113 267.849 72.8805C268.196 72.6324 268.56 72.4042 268.876 72.2291L269.174 72.0729Z",
    fill: "#D07400",
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.254 107.893V110.723H265.858C265.858 106.559 265.599 103.919 263.426 100.47C262.356 98.771 261.755 98.1257 260.274 96.8073C260.055 96.6116 259.966 96.5705 259.754 96.3842C259.492 96.1546 259.48 96.1239 259.171 95.9192C258.304 95.3449 257.674 94.999 256.702 94.5087C252.848 92.5646 246.676 92.4916 242.829 94.2993C241.224 95.0535 240.557 95.3796 239.215 96.4513C238.158 97.2952 237.195 98.3023 236.384 99.3861C235.813 100.149 235.349 100.871 234.896 101.777C234.652 102.268 234.484 102.568 234.315 103.083C233.821 104.587 233.254 106.181 233.254 107.893Z",
    fill: "#FFC500",
    stroke: "#FFF5BB",
    strokeWidth: 0.766888,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.56 93.74C261.817 94.1235 263.214 95.1845 263.597 95.6866C263.823 95.9828 264.009 96.1303 264.261 96.3849C264.667 96.7935 265.049 97.3749 265.41 97.8572C265.821 98.4065 266.109 98.9346 266.468 99.5248C267.739 101.614 268.898 105.271 268.898 107.893H286.93V104.55C286.876 102.437 286.607 100.526 285.462 98.2472C285.066 97.4574 284.628 96.7275 284.115 96.0298C281.106 91.933 276.731 89.9658 271.624 89.9658C269.188 89.9658 266.454 90.6028 264.67 91.6087L261.56 93.7398L261.56 93.74Z",
    fill: "#FFC500",
    stroke: "#FFF5BB",
    strokeWidth: 0.766888,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.754 78.8536C239.754 81.4448 240.115 83.4095 241.64 85.5643L242.766 86.9541C243.989 88.185 245.719 89.2128 247.468 89.5905C249.687 90.0695 251.789 89.773 253.628 88.8487C255.69 87.8125 257.546 85.9592 258.43 83.7962C259.551 81.0507 259.788 77.8859 258.485 75.114C257.444 72.8992 256.1 71.1895 253.803 70.0469C251.083 68.694 248.099 68.6006 245.343 69.9753C244.2 70.5451 243.468 71.2157 242.611 72.0656C241.21 73.4533 239.754 76.1095 239.754 78.8538L239.754 78.8536Z",
    fill: "#FFC700",
    stroke: "#FFF5BB",
    strokeWidth: 0.766888,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.196 69.6819C248.051 68.2581 251.144 68.3579 253.949 69.7534C256.33 70.938 257.719 72.714 258.782 74.9746C260.134 77.85 259.88 81.1133 258.733 83.9202C257.816 86.1653 255.899 88.0744 253.775 89.1417C251.869 90.0999 249.69 90.4057 247.399 89.9111C245.581 89.5184 243.796 88.4554 242.534 87.1852L242.522 87.1735L241.379 85.7625L241.372 85.7538C239.957 83.7538 239.515 81.9063 239.439 79.6465L239.426 79.6595V78.8539C239.426 76.0069 240.929 73.2704 242.38 71.8327C243.244 70.9768 244.006 70.2758 245.196 69.6819ZM240.082 78.8007V78.8537C240.082 81.4007 240.434 83.289 241.902 85.3662L243.011 86.7347C244.194 87.9211 245.864 88.9085 247.538 89.27C249.683 89.7334 251.71 89.4461 253.481 88.5558C255.481 87.5507 257.276 85.7532 258.126 83.6722C259.223 80.988 259.443 77.9219 258.188 75.2536C257.169 73.0844 255.869 71.4411 253.657 70.3405C251.023 69.0301 248.147 68.9432 245.489 70.2688C244.395 70.8145 243.693 71.4547 242.841 72.2985C241.501 73.6273 240.101 76.1777 240.082 78.8007Z",
    fill: "#FFF5BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.414 88.2886C274.825 88.2886 276.775 87.1943 278.693 84.5598C281.079 81.2818 280.645 75.9458 277.731 73.061C276.841 72.1804 276.899 72.2641 275.985 71.6624C273.717 70.1693 270.676 70.1247 268.267 71.3032C267.525 71.6663 266.294 72.4859 265.797 73.1314C263.848 75.6638 262.954 77.6771 263.549 81.1624C264.177 84.8385 267.506 88.2886 271.414 88.2886Z",
    fill: "url(#paint4_linear_150_150)",
    stroke: "#FFF5BB",
    strokeWidth: 0.766888,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.122 80.8381C294.293 84.4151 294.938 88.2264 294.938 92.2131C294.938 96.0272 294.352 99.7238 293.237 103.186C289.714 106.151 282.375 111.48 275.293 116.536C268.212 121.592 261.387 126.375 258.889 128.256C249.915 128.255 241.702 124.972 235.365 119.519C242.038 114.738 288.008 84.2274 293.122 80.8381Z",
    fill: "#FFF5BB",
    fillOpacity: 0.360784,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.948 56.4038C266.52 56.8141 269.976 57.7502 273.198 59.1538C272.059 59.9133 270.92 60.6737 269.781 61.4331L266.345 63.7231C260.591 67.5253 254.88 71.3273 249.216 75.2476L246.791 76.9351C243.444 79.3134 240.126 81.7217 236.815 84.144L226.884 91.4399C225.538 92.4342 224.193 93.4277 222.79 94.3638C222.733 93.6664 222.733 92.9684 222.733 92.2124C222.733 90.1003 222.909 88.1056 223.26 86.1108C227.267 82.9774 231.229 79.845 235.263 76.7905L236.998 75.4858C241.974 71.7424 246.984 68.0647 252.002 64.4038L257.022 60.7466C259.017 59.2797 260.953 57.812 262.948 56.4038Z",
    fill: "#FFF5BB",
    fillOpacity: 0.360784,
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.552 134.486C223.434 134.339 223.258 134.133 223.104 133.914C222.951 133.694 222.82 133.461 222.791 133.258H222.793L222.788 133.253L221.502 131.799C221.071 131.315 220.637 130.83 220.204 130.345C219.771 129.861 219.338 129.377 218.907 128.892L217.621 127.439C215.925 125.538 214.185 123.637 212.597 121.618L211.925 120.746V120.745L211.272 119.881C210.197 118.433 209.182 116.944 208.185 115.444L206.993 113.64C206.2 112.436 205.348 111.261 204.512 110.08C203.78 109.046 203.059 108.007 202.398 106.937L202.119 106.476L201.838 106.011C201.378 105.232 200.959 104.433 200.551 103.629L200.064 102.661V102.66C199.5 101.582 199.024 100.503 198.441 99.4625L198.185 99.0192V99.0182C197.685 98.2246 197.04 97.3601 196.563 96.4069C196.117 95.5135 195.819 94.5435 195.928 93.485L195.955 93.2721V93.2711C196.218 91.6335 197.432 90.8284 198.89 90.5133C200.166 90.2375 201.628 90.3381 202.799 90.5836L203.281 90.6969C204.923 91.1073 206.431 92.0117 207.766 93.0573L208.327 93.5133C210.022 94.8999 211.537 96.5561 212.912 98.2858L213.492 99.0309V99.0319C214.879 100.83 216.132 102.672 217.249 104.599L217.72 105.43C218.285 106.457 218.85 107.531 219.494 108.531L219.775 108.955C220.392 109.88 221.109 110.706 221.85 111.507L222.596 112.303C224.137 113.933 225.745 115.53 227.344 117.143L228.938 118.763C230.684 120.562 232.386 122.36 234.201 124.041L234.986 124.754C236.683 126.296 238.559 127.613 240.496 128.823L241.33 129.335L241.333 129.336C244.372 130.349 247.51 131.098 250.623 131.83L253.724 132.566C255.662 133.036 257.645 133.359 259.634 133.668C261.374 133.937 263.12 134.195 264.847 134.531L265.586 134.68H265.587C265.762 134.71 265.938 134.753 266.114 134.797C266.29 134.841 266.467 134.885 266.644 134.915L266.673 134.92L266.654 134.896L265.068 132.959C263.472 130.977 261.875 129.046 260.036 127.312L259.665 126.967C258.167 125.602 256.537 124.369 254.874 123.169L253.204 121.975C251.252 120.639 249.344 119.304 247.482 117.811L246.688 117.161C244.871 115.619 243.055 113.976 241.723 111.988L241.463 111.586C240.213 109.597 239.679 107.278 240.553 105.057L240.642 104.842C241.027 103.962 241.617 103.033 242.509 102.535L242.691 102.441C243.408 102.134 244.214 102.14 244.993 102.342L245.325 102.441C246.073 102.705 246.755 103.068 247.421 103.456L248.083 103.849C248.612 104.172 249.155 104.481 249.706 104.782L251.372 105.67C253.735 106.902 256.01 108.227 258.391 109.404L259.418 109.898C263.514 111.836 267.842 113.246 272.178 114.597L276.507 115.947C281.626 117.598 286.642 119.508 291.41 121.918L292.36 122.406C297.094 124.883 301.57 127.773 305.788 131.027L306.628 131.683C310.667 134.925 314.594 138.552 317.184 143.098L317.43 143.542C318.559 145.698 319.241 147.99 319.747 150.339L319.954 151.348C320.174 152.493 320.328 153.638 320.466 154.783L320.6 155.927C320.6 156.045 320.614 156.149 320.629 156.252C320.644 156.354 320.658 156.456 320.658 156.573H320.657L320.659 156.577C321.188 157.927 321.717 159.263 322.245 160.599L323.83 164.622C324.682 166.795 325.548 168.967 326.422 171.14L329.057 177.658C330.547 181.46 331.992 185.262 333.353 189.064L333.931 190.694C335.215 194.496 336.41 198.298 337.79 202.061L338.394 203.672C339.605 206.92 340.919 210.168 341.9 213.512L342.092 214.179C342.092 214.356 342.106 214.518 342.121 214.679C342.136 214.84 342.149 214.999 342.149 215.173C342.089 215.233 341.976 215.346 341.919 215.403C340.776 216.018 339.179 216.4 337.697 216.634C336.586 216.81 335.54 216.904 334.802 216.952L334.176 216.986H334.175C331.885 217.162 329.537 217.163 327.247 217.163C322.348 217.163 317.397 217.06 312.491 216.66L311.511 216.576C308.649 216.301 305.838 215.819 303.079 214.986L302.528 214.814C302.411 214.756 302.294 214.711 302.177 214.668C302.061 214.624 301.945 214.58 301.83 214.523L301.655 213.297C301.626 213.15 301.611 212.989 301.597 212.828C301.589 212.747 301.581 212.666 301.572 212.587L301.538 212.356C301.076 207.835 300.657 203.359 300.167 198.849L299.952 196.914C299.438 192.495 298.879 188.121 298.236 183.753L297.956 181.88C297.494 178.644 297.166 175.407 296.658 172.209L296.429 170.84V170.839C296.37 170.575 296.312 170.296 296.253 170.017C296.194 169.739 296.135 169.46 296.076 169.196L296.065 169.198L296.083 169.194L296.07 169.188L295.622 168.98C294.56 168.526 293.395 168.269 292.368 168.012H292.369C290.122 167.396 287.876 166.911 285.604 166.435L283.325 165.957C281.828 165.634 280.345 165.296 278.862 164.959C278.121 164.79 277.379 164.622 276.636 164.455L274.399 163.961C271.779 163.395 269.158 162.875 266.577 162.282L265.474 162.023C259.803 160.647 254.289 158.754 248.638 157.12L247.505 156.797C246.874 156.62 246.228 156.463 245.578 156.304C244.928 156.146 244.275 155.985 243.629 155.805C242.499 155.491 241.392 155.115 240.367 154.574L239.933 154.332C239.376 154.009 238.877 153.598 238.386 153.172C238.017 152.853 237.652 152.526 237.27 152.221L236.88 151.924C236.38 151.572 235.851 151.263 235.323 150.948C234.927 150.711 234.53 150.47 234.146 150.204L233.768 149.928C232.793 149.21 232.088 148.312 231.494 147.273L231.246 146.82C230.542 145.47 229.895 144.177 229.072 142.884H229.073C228.633 142.15 228.177 141.431 227.715 140.712L226.312 138.539L225.975 138.037C225.63 137.539 225.268 137.054 224.91 136.564C224.434 135.912 223.965 135.252 223.555 134.549V134.493H223.558L223.552 134.486Z",
    fill: "#C3825D",
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-235-inside-1_150_150",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.06 95.971C197.588 97.0867 198.352 98.0849 198.998 99.1419C199.702 100.316 200.29 101.608 200.935 102.9C202.227 105.425 203.637 107.774 205.281 110.064C206.866 112.296 208.393 114.644 209.92 116.935C211.505 119.283 213.15 121.574 215.029 123.688C217.025 125.978 219.081 128.209 221.077 130.5C225.07 134.962 229.063 139.425 232.88 144.006C233.526 144.769 234.114 145.532 234.76 146.296C235.288 147.059 235.816 147.822 236.345 148.586C236.11 148.469 235.875 148.351 235.582 148.292C235.347 148.057 235.171 147.823 234.936 147.588C231.941 144.006 228.946 140.482 225.834 136.959C225.893 137.076 225.834 137.135 225.775 137.194C226.01 137.546 226.304 137.898 226.538 138.251C227.419 139.484 228.241 140.834 229.122 142.068C229.944 143.242 230.766 144.416 231.412 145.708C232 146.824 232.528 148.116 233.409 149.056C234.29 149.936 235.464 150.524 236.521 151.17C237.637 151.874 238.518 152.755 239.575 153.577C240.69 154.458 242.041 154.928 243.333 155.339C244.683 155.75 245.975 156.044 247.326 156.455C253.257 158.158 259.129 160.213 265.119 161.681C268.055 162.386 271.05 163.032 274.044 163.677C277.039 164.323 280.034 165.087 283.088 165.733C286.494 166.496 289.9 167.201 293.246 168.14C293.54 168.258 293.775 168.317 294.069 168.434C294.832 168.728 295.537 169.021 296.241 169.432C296.535 169.609 296.829 169.785 297.064 170.02C297.181 170.137 297.357 170.254 297.475 170.431C297.592 170.548 297.709 170.724 297.768 170.842C297.886 171.018 297.944 171.135 298.062 171.311C298.062 171.311 298.062 171.311 298.062 171.37C297.709 170.9 297.299 170.489 296.829 170.196C297.651 173.66 298.003 177.184 298.473 180.707C299.119 185.522 299.882 190.338 300.411 195.153C300.998 200.379 301.468 205.546 301.938 210.773C302.055 212.065 302.172 213.357 302.29 214.649C304.58 215.412 306.988 215.882 309.395 216.234C311.862 216.587 314.328 216.645 316.794 216.763C319.319 216.88 321.844 216.997 324.37 216.997C327.071 217.056 329.772 216.997 332.473 216.88C334.822 216.763 337.171 216.586 339.461 215.999C340.166 215.823 340.988 215.53 341.693 215.177C340.636 211.889 339.403 208.718 338.169 205.488C336.525 201.26 335.174 196.973 333.648 192.687C330.653 183.937 327.13 175.363 323.783 166.673C322.726 163.971 321.727 161.211 320.788 158.51C320.788 158.804 320.847 159.097 320.847 159.391C320.847 159.978 320.847 160.565 320.612 161.094C320.612 160.976 320.612 160.918 320.612 160.8C320.553 159.978 320.435 159.097 320.318 158.275C320.259 157.864 320.201 157.394 320.083 156.983C320.083 156.924 320.083 156.866 320.083 156.866C320.025 156.631 320.025 156.396 319.966 156.102C319.966 156.044 319.907 155.985 319.907 155.926V155.867C319.848 155.456 319.79 154.987 319.731 154.575C319.79 154.634 319.79 154.752 319.848 154.81C319.496 152.168 318.967 149.467 318.086 147C316.325 142.009 312.567 137.898 308.632 134.492C300.352 127.387 290.722 121.867 280.446 118.285C275.043 116.406 269.465 114.879 264.121 112.882C261.42 111.884 258.777 110.651 256.193 109.3C253.786 108.008 251.319 106.834 248.97 105.425C248.09 104.896 247.209 104.309 246.269 103.839C245.447 103.428 244.449 103.076 243.568 103.311C242.394 103.663 241.63 104.896 241.219 105.953C240.75 107.128 240.75 108.42 241.102 109.653C241.806 112.06 243.685 113.94 245.447 115.642C247.385 117.463 249.499 118.99 251.613 120.516C253.727 121.985 255.9 123.453 257.896 125.038C259.893 126.623 261.713 128.326 263.357 130.264C264.59 131.674 265.765 133.142 266.881 134.61C266.939 134.786 266.998 134.962 267.116 135.138C267.35 135.549 267.585 135.96 267.938 136.313C268.525 137.076 269.23 137.781 269.993 138.426C270.169 138.603 270.345 138.72 270.521 138.896C271.402 139.895 272.283 140.834 273.223 141.715C273.516 141.95 273.751 142.185 274.045 142.478C274.456 142.948 274.926 143.418 275.337 143.946C275.513 144.122 275.631 144.299 275.807 144.475C272.459 142.185 269.817 139.131 267.292 135.96C264.943 135.431 262.594 135.02 260.186 134.668C256.076 134.081 252.083 133.141 248.09 132.143C246.622 131.791 245.153 131.438 243.744 131.027H243.803C243.392 130.851 242.922 130.734 242.511 130.558C242.159 130.44 241.865 130.323 241.513 130.146C241.219 129.97 240.867 129.853 240.573 129.677C240.397 129.559 240.221 129.501 240.045 129.383C239.986 129.324 239.868 129.266 239.81 129.207C237.52 127.739 235.347 126.036 233.35 124.157C231.354 122.278 229.475 120.222 227.537 118.285C225.481 116.229 223.426 114.233 221.488 112.06C220.608 111.062 219.727 110.064 219.022 108.948C218.317 107.832 217.671 106.658 217.025 105.483C215.792 103.252 214.383 101.196 212.797 99.1999C211.212 97.1446 209.45 95.2655 207.454 93.68C205.986 92.5642 204.459 91.6835 202.639 91.3898C201.229 91.155 199.526 91.0962 198.176 91.8009C196.532 92.5058 196.414 94.4437 197.06 95.9706L197.06 95.971Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M197.06 95.971C197.588 97.0867 198.352 98.0849 198.998 99.1419C199.702 100.316 200.29 101.608 200.935 102.9C202.227 105.425 203.637 107.774 205.281 110.064C206.866 112.296 208.393 114.644 209.92 116.935C211.505 119.283 213.15 121.574 215.029 123.688C217.025 125.978 219.081 128.209 221.077 130.5C225.07 134.962 229.063 139.425 232.88 144.006C233.526 144.769 234.114 145.532 234.76 146.296C235.288 147.059 235.816 147.822 236.345 148.586C236.11 148.469 235.875 148.351 235.582 148.292C235.347 148.057 235.171 147.823 234.936 147.588C231.941 144.006 228.946 140.482 225.834 136.959C225.893 137.076 225.834 137.135 225.775 137.194C226.01 137.546 226.304 137.898 226.538 138.251C227.419 139.484 228.241 140.834 229.122 142.068C229.944 143.242 230.766 144.416 231.412 145.708C232 146.824 232.528 148.116 233.409 149.056C234.29 149.936 235.464 150.524 236.521 151.17C237.637 151.874 238.518 152.755 239.575 153.577C240.69 154.458 242.041 154.928 243.333 155.339C244.683 155.75 245.975 156.044 247.326 156.455C253.257 158.158 259.129 160.213 265.119 161.681C268.055 162.386 271.05 163.032 274.044 163.677C277.039 164.323 280.034 165.087 283.088 165.733C286.494 166.496 289.9 167.201 293.246 168.14C293.54 168.258 293.775 168.317 294.069 168.434C294.832 168.728 295.537 169.021 296.241 169.432C296.535 169.609 296.829 169.785 297.064 170.02C297.181 170.137 297.357 170.254 297.475 170.431C297.592 170.548 297.709 170.724 297.768 170.842C297.886 171.018 297.944 171.135 298.062 171.311C298.062 171.311 298.062 171.311 298.062 171.37C297.709 170.9 297.299 170.489 296.829 170.196C297.651 173.66 298.003 177.184 298.473 180.707C299.119 185.522 299.882 190.338 300.411 195.153C300.998 200.379 301.468 205.546 301.938 210.773C302.055 212.065 302.172 213.357 302.29 214.649C304.58 215.412 306.988 215.882 309.395 216.234C311.862 216.587 314.328 216.645 316.794 216.763C319.319 216.88 321.844 216.997 324.37 216.997C327.071 217.056 329.772 216.997 332.473 216.88C334.822 216.763 337.171 216.586 339.461 215.999C340.166 215.823 340.988 215.53 341.693 215.177C340.636 211.889 339.403 208.718 338.169 205.488C336.525 201.26 335.174 196.973 333.648 192.687C330.653 183.937 327.13 175.363 323.783 166.673C322.726 163.971 321.727 161.211 320.788 158.51C320.788 158.804 320.847 159.097 320.847 159.391C320.847 159.978 320.847 160.565 320.612 161.094C320.612 160.976 320.612 160.918 320.612 160.8C320.553 159.978 320.435 159.097 320.318 158.275C320.259 157.864 320.201 157.394 320.083 156.983C320.083 156.924 320.083 156.866 320.083 156.866C320.025 156.631 320.025 156.396 319.966 156.102C319.966 156.044 319.907 155.985 319.907 155.926V155.867C319.848 155.456 319.79 154.987 319.731 154.575C319.79 154.634 319.79 154.752 319.848 154.81C319.496 152.168 318.967 149.467 318.086 147C316.325 142.009 312.567 137.898 308.632 134.492C300.352 127.387 290.722 121.867 280.446 118.285C275.043 116.406 269.465 114.879 264.121 112.882C261.42 111.884 258.777 110.651 256.193 109.3C253.786 108.008 251.319 106.834 248.97 105.425C248.09 104.896 247.209 104.309 246.269 103.839C245.447 103.428 244.449 103.076 243.568 103.311C242.394 103.663 241.63 104.896 241.219 105.953C240.75 107.128 240.75 108.42 241.102 109.653C241.806 112.06 243.685 113.94 245.447 115.642C247.385 117.463 249.499 118.99 251.613 120.516C253.727 121.985 255.9 123.453 257.896 125.038C259.893 126.623 261.713 128.326 263.357 130.264C264.59 131.674 265.765 133.142 266.881 134.61C266.939 134.786 266.998 134.962 267.116 135.138C267.35 135.549 267.585 135.96 267.938 136.313C268.525 137.076 269.23 137.781 269.993 138.426C270.169 138.603 270.345 138.72 270.521 138.896C271.402 139.895 272.283 140.834 273.223 141.715C273.516 141.95 273.751 142.185 274.045 142.478C274.456 142.948 274.926 143.418 275.337 143.946C275.513 144.122 275.631 144.299 275.807 144.475C272.459 142.185 269.817 139.131 267.292 135.96C264.943 135.431 262.594 135.02 260.186 134.668C256.076 134.081 252.083 133.141 248.09 132.143C246.622 131.791 245.153 131.438 243.744 131.027H243.803C243.392 130.851 242.922 130.734 242.511 130.558C242.159 130.44 241.865 130.323 241.513 130.146C241.219 129.97 240.867 129.853 240.573 129.677C240.397 129.559 240.221 129.501 240.045 129.383C239.986 129.324 239.868 129.266 239.81 129.207C237.52 127.739 235.347 126.036 233.35 124.157C231.354 122.278 229.475 120.222 227.537 118.285C225.481 116.229 223.426 114.233 221.488 112.06C220.608 111.062 219.727 110.064 219.022 108.948C218.317 107.832 217.671 106.658 217.025 105.483C215.792 103.252 214.383 101.196 212.797 99.1999C211.212 97.1446 209.45 95.2655 207.454 93.68C205.986 92.5642 204.459 91.6835 202.639 91.3898C201.229 91.155 199.526 91.0962 198.176 91.8009C196.532 92.5058 196.414 94.4437 197.06 95.9706L197.06 95.971Z",
    fill: "#FFC08C",
    stroke: "#FE9278",
    strokeWidth: 0.0453914,
    mask: "url(#path-235-inside-1_150_150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.511 103.086C244.33 102.882 245.149 103.126 245.891 103.465L246.205 103.615C246.674 103.85 247.129 104.114 247.577 104.385L248.906 105.2C250.081 105.876 251.285 106.522 252.496 107.16L256.129 109.076C258.39 110.258 260.652 111.306 263.031 112.257L264.057 112.658C266.73 113.686 269.461 114.567 272.199 115.426C274.595 116.178 276.996 116.913 279.368 117.714L280.383 118.062C290.337 121.588 299.685 126.823 307.786 133.606L308.566 134.267C312.377 137.566 316.077 141.525 317.851 146.305L318.016 146.77C318.891 149.278 319.418 151.902 319.77 154.528C319.759 154.506 319.75 154.482 319.741 154.455C319.727 154.412 319.711 154.365 319.679 154.333L319.656 154.309L319.661 154.343C319.69 154.548 319.719 154.768 319.749 154.989L319.837 155.635V155.692C319.837 155.724 319.853 155.757 319.867 155.785C319.882 155.815 319.895 155.842 319.895 155.868V155.871C319.924 155.988 319.939 156.104 319.954 156.229C319.968 156.353 319.984 156.485 320.013 156.631H320.012V156.75C320.057 157.058 320.101 157.4 320.17 157.726L320.248 158.044C320.336 158.66 320.424 159.276 320.487 159.916L320.542 160.567V160.86L320.563 160.864C320.74 160.333 320.799 159.744 320.799 159.156C320.799 158.905 320.797 158.653 320.76 158.401C321.452 160.429 322.176 162.426 322.931 164.415L323.713 166.443C326.851 174.535 330.144 182.576 333.01 190.807L333.578 192.456C334.862 196.207 336.103 199.958 337.494 203.67L338.099 205.258C339.331 208.426 340.564 211.653 341.62 214.938C341.535 214.994 341.45 215.036 341.364 215.079C341.28 215.121 341.196 215.164 341.111 215.219C340.758 213.932 340.173 212.761 339.589 211.592H339.59C339.443 211.18 339.266 210.783 339.09 210.402C338.914 210.02 338.738 209.654 338.592 209.303V209.302L338.591 209.3L338.441 208.967C338.297 208.632 338.166 208.29 338.04 207.944L337.534 206.541C337.005 205.088 336.51 203.601 335.998 202.107L335.478 200.611C335.126 199.612 334.774 198.628 334.422 197.645L333.364 194.679C332.307 191.728 331.251 188.777 330.219 185.802L329.195 182.818C328.226 179.867 327.224 176.916 326.189 173.965L325.143 171.014C323.852 167.492 322.853 163.792 321.092 160.445C321.09 160.427 321.082 160.414 321.068 160.406C321.054 160.397 321.034 160.393 321.014 160.393C320.995 160.393 320.973 160.397 320.953 160.405L320.896 160.44L320.894 160.443C320.542 161.148 320.321 161.92 320.085 162.707L319.837 163.498C319.668 164.005 319.443 164.565 319.166 165.076C319.191 164.924 319.217 164.772 319.242 164.626L319.331 164.15C319.827 161.065 319.702 157.929 319.152 154.838L319.037 154.221C318.431 151.027 317.36 147.885 315.874 144.988L315.571 144.411C314.139 141.603 312.294 139.053 310.085 136.809L309.638 136.364L309.094 135.863C306.714 133.714 304.082 131.861 301.415 130.115L300.182 129.316C298.692 128.339 297.202 127.363 295.672 126.465L295.014 126.085C293.421 125.16 291.828 124.326 290.195 123.541L289.493 123.208C286.204 121.615 282.825 120.247 279.396 118.947L277.925 118.392H277.924C275.927 117.658 273.931 116.939 271.934 116.227L265.944 114.106C262.256 112.785 258.568 111.464 255.074 109.707L254.378 109.35C252.793 108.528 251.325 107.588 249.798 106.649H249.799C248.873 106.032 247.903 105.506 246.887 105.069L246.449 104.886L246.045 104.736C245.152 104.419 244.162 104.181 243.2 104.272L242.978 104.298C242.464 104.412 242.005 104.638 241.602 104.92C242.013 104.115 242.65 103.374 243.512 103.087L243.511 103.086Z",
    fill: "#FDDBBF",
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.403 90.9924C201.788 90.9975 202.124 91.0518 202.459 91.1077V91.1086C204.05 91.4167 205.418 92.0834 206.717 92.9924L207.27 93.3967C209.067 94.7319 210.64 96.3816 212.028 98.1497L212.612 98.9143C214.138 100.911 215.606 103.025 216.839 105.197V105.196C217.324 106.076 217.809 106.957 218.318 107.814L218.835 108.661C219.541 109.778 220.364 110.777 221.303 111.776V111.775C222.757 113.36 224.31 114.913 225.837 116.457L227.352 118C229.047 119.695 230.699 121.481 232.422 123.16L233.166 123.872C235.163 125.752 237.336 127.397 239.626 128.924V128.923C239.657 128.953 239.701 128.983 239.745 129.012L239.86 129.099L239.862 129.1C239.951 129.159 240.039 129.203 240.127 129.247C240.171 129.269 240.216 129.291 240.259 129.315L240.39 129.394C240.538 129.482 240.7 129.556 240.862 129.629C240.942 129.666 241.023 129.702 241.101 129.74L241.33 129.864H241.331C241.536 129.981 241.727 130.069 241.904 130.143L242.388 130.334H242.389L242.707 130.457C242.815 130.496 242.926 130.532 243.036 130.569C243.236 130.636 243.436 130.704 243.625 130.781L243.624 130.804C244.358 131.01 245.092 131.2 245.819 131.384L247.969 131.92C251.463 132.742 254.958 133.564 258.531 134.19L260.067 134.445C262.474 134.797 264.821 135.149 267.168 135.736C267.225 135.793 267.268 135.85 267.312 135.908C267.35 135.959 267.389 136.01 267.437 136.062C266.39 135.89 265.314 135.86 264.239 135.802C263.288 135.751 262.339 135.677 261.409 135.463L261.011 135.363C258.134 134.643 255.165 134.238 252.226 133.755L250.968 133.542C248.05 133.047 245.133 132.603 242.313 131.776L241.75 131.605C240.429 131.164 239.058 130.672 237.876 129.936L237.643 129.785C236.565 129.067 235.622 128.213 234.695 127.264L234.297 126.851C233.505 126.014 232.713 125.177 231.895 124.34L231.068 123.504L227.369 119.804C225.262 117.698 223.29 115.457 221.375 113.159L220.557 112.171C218.708 109.962 216.993 107.663 215.414 105.235L214.745 104.187V104.186C213.093 101.598 211.234 99.2167 209.121 96.9934L208.695 96.551V96.55C206.815 94.6705 204.759 92.9669 202.527 91.6155H202.526C202.188 91.3905 201.797 91.166 201.403 90.9924Z",
    fill: "#FDDBBF",
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.014 171.015C297.984 170.925 297.94 170.85 297.888 170.776L297.719 170.542C297.631 170.41 297.576 170.31 297.503 170.219L297.424 170.129C297.366 170.07 297.307 169.998 297.24 169.924C297.175 169.85 297.101 169.777 297.012 169.718H297.013C296.836 169.541 296.625 169.398 296.407 169.263L296.189 169.129C295.836 168.923 295.468 168.746 295.101 168.585L294.014 168.13C293.867 168.071 293.735 168.026 293.603 167.982L293.192 167.836H293.191C290.68 167.131 288.137 166.558 285.585 165.994L283.031 165.428C281.534 165.105 280.036 164.753 278.531 164.4C277.403 164.136 276.27 163.872 275.13 163.62L273.988 163.373C271.367 162.808 268.747 162.288 266.166 161.655L265.063 161.376C259.771 160.091 254.659 158.358 249.49 156.804L247.27 156.15C246.257 155.886 245.244 155.622 244.256 155.333L243.278 155.034C242.012 154.649 240.798 154.212 239.734 153.434L239.523 153.274C238.65 152.556 237.821 151.791 236.879 151.139L236.468 150.866C235.476 150.26 234.384 149.707 233.527 148.916L233.358 148.754C232.654 148.05 232.215 147.183 231.791 146.297L231.364 145.41C230.879 144.44 230.295 143.537 229.687 142.65L229.073 141.767C228.192 140.476 227.369 139.183 226.489 137.95H226.488C226.256 137.602 226.024 137.254 225.736 136.906C225.747 136.902 225.758 136.897 225.767 136.888C225.781 136.873 225.792 136.853 225.8 136.83C225.811 136.797 225.813 136.758 225.804 136.716C227.318 138.463 228.818 140.225 230.318 141.987C231.829 143.763 233.341 145.539 234.867 147.3V147.301C235.044 147.536 235.28 147.772 235.515 148.007L235.514 148.008L235.518 148.009C235.752 148.126 235.988 148.244 236.283 148.304L236.312 148.309L236.295 148.286L234.71 145.996L234.709 145.995L234.235 145.423C234.079 145.232 233.924 145.041 233.77 144.85C233.616 144.66 233.462 144.468 233.306 144.277L232.83 143.705C229.967 140.27 227.005 136.9 224.019 133.548L221.027 130.198C220.028 129.053 219.015 127.923 218.002 126.793C217.496 126.227 216.989 125.662 216.485 125.095L214.979 123.387C213.335 121.537 211.871 119.553 210.468 117.513L209.87 116.635C209.078 115.49 208.314 114.344 207.551 113.199C207.17 112.627 206.788 112.055 206.403 111.482L205.232 109.765L205.231 109.764L204.625 108.902C203.435 107.173 202.369 105.402 201.377 103.54L200.887 102.601C200.322 101.523 199.801 100.398 199.207 99.3075L198.948 98.8427L198.948 98.8417L198.481 98.2264C198.075 97.6806 197.64 97.055 197.278 96.3778L197.07 95.9657C196.427 94.446 196.544 92.5238 198.108 91.6434L198.107 91.6464L198.123 91.6346C198.21 91.5767 198.312 91.5332 198.415 91.4891C198.513 91.4471 198.611 91.403 198.698 91.3475C198.784 91.6078 198.871 91.8679 198.958 92.08L199.046 92.2762C199.457 93.1506 199.96 93.9352 200.63 94.5907L200.928 94.8641C201.575 95.4227 202.295 95.8778 203.03 96.3182C203.58 96.6486 204.138 96.9706 204.68 97.3212L205.216 97.6835C206.36 98.4316 207.306 99.3776 208.203 100.374L209.089 101.381C210.894 103.582 212.501 105.949 214.034 108.333L215.548 110.717C217.045 113.139 218.543 115.528 220.065 117.909L221.596 120.288C223.578 123.371 225.664 126.351 228.046 129.132L228.527 129.685C229.554 130.867 230.672 132.004 231.88 132.978L232.404 133.387C233.373 134.136 234.408 134.818 235.46 135.46L236.516 136.088V136.089C242.078 139.117 248.259 140.7 254.478 141.612L255.722 141.786C258.651 142.146 261.582 142.056 264.51 142.106L265.765 142.139C269.053 142.256 272.515 142.491 275.448 144.134L275.448 144.135H275.568C275.597 144.163 275.626 144.178 275.655 144.192C275.684 144.207 275.712 144.221 275.74 144.249L275.756 144.232C275.728 144.204 275.714 144.177 275.699 144.147C275.685 144.119 275.669 144.09 275.641 144.06C275.641 144.034 275.641 144.018 275.633 144.001C275.629 143.992 275.622 143.984 275.614 143.974C275.605 143.965 275.594 143.954 275.579 143.939L275.583 143.935H275.572C275.547 143.935 275.535 143.925 275.521 143.91C275.507 143.896 275.491 143.88 275.46 143.878C275.432 143.849 275.404 143.808 275.375 143.765L275.285 143.645C274.875 143.177 274.463 142.647 273.993 142.178H273.994L273.993 142.177L273.782 142C273.715 141.94 273.648 141.88 273.582 141.817L273.172 141.414H273.171C272.467 140.754 271.795 140.06 271.132 139.334L270.471 138.596C270.382 138.507 270.293 138.434 270.205 138.36C270.161 138.323 270.117 138.286 270.073 138.248L269.942 138.126V138.125L269.414 137.63C269.064 137.292 268.718 136.941 268.382 136.574L267.887 136.013C267.667 135.749 267.447 135.451 267.252 135.146L267.067 134.84C267.037 134.751 266.993 134.663 266.949 134.576C266.905 134.488 266.861 134.401 266.832 134.313H266.833L266.83 134.309L265.069 132.115C264.775 131.752 264.481 131.39 264.188 131.031L263.307 129.964C261.868 128.268 260.294 126.752 258.585 125.337L257.844 124.736C255.788 123.151 253.675 121.682 251.561 120.214H251.56C249.523 118.783 247.539 117.352 245.751 115.68L245.396 115.342L244.733 114.711C243.294 113.313 241.885 111.708 241.198 109.802L241.053 109.356C240.723 108.202 240.703 106.997 241.088 105.886L241.17 105.665L241.171 105.664C241.347 105.166 241.61 104.624 241.954 104.155C242.293 103.693 242.71 103.304 243.198 103.097C242.55 105.406 243.748 107.662 245.299 109.431L245.615 109.778V109.779C247.708 111.927 250.369 113.611 253.114 114.829L253.663 115.066C254.515 115.419 255.366 115.742 256.218 116.057L258.773 117.004C260.093 117.488 261.348 118.072 262.612 118.705L263.88 119.352C266.963 120.997 270.046 122.596 273.089 124.268L274.392 124.99C280.722 128.513 287.104 132.139 293.054 136.352L294.239 137.203C296.936 139.184 299.477 141.423 301.429 144.162L301.811 144.717C303.711 147.542 304.892 150.681 306.181 153.783L306.742 155.108C307.937 157.896 309.408 160.907 311.905 162.803L312.149 162.982C313.086 163.699 314.231 164.157 315.438 164.066L315.68 164.041C317.142 163.924 318.37 163.052 319.422 162.119C319.067 165.634 317.949 169.545 314.559 171.3C314.544 171.3 314.531 171.305 314.522 171.312C314.511 171.321 314.505 171.332 314.501 171.345C314.493 171.369 314.492 171.4 314.492 171.429L314.493 171.432C315.462 174.867 316.365 178.302 317.227 181.737L318.075 185.173C319.947 192.549 321.664 199.978 323.904 207.266L324.359 208.721C325.237 211.473 326.058 214.345 327.87 216.692H324.311L320.524 216.597C319.892 216.578 319.261 216.558 318.63 216.535L316.737 216.458C314.578 216.355 312.42 216.252 310.263 216.031L309.338 215.93C306.934 215.636 304.588 215.108 302.241 214.346L301.89 210.478C301.479 205.906 301.068 201.332 300.578 196.799L300.364 194.858C299.967 191.247 299.438 187.635 298.926 184.023L298.425 180.412C297.957 176.898 297.604 173.383 296.786 169.927C297.245 170.218 297.648 170.623 297.994 171.084L298.003 171.077H298.017L298.015 171.074V171.017L298.014 171.015Z",
    fill: "#FFCB9F",
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.669 104.665C241.563 105.52 241.62 106.266 241.735 107.011L241.728 107.013L241.738 107.018C242.047 108.457 242.76 109.806 243.641 111.025L244.029 111.539C245.982 114.11 248.475 116.23 251.075 118.136L252.194 118.941C253.383 119.821 254.605 120.669 255.835 121.484L257.068 122.287C258.97 123.521 260.915 124.664 262.749 125.953L263.527 126.515C264.451 127.183 265.331 127.896 266.166 128.654L266.52 128.981C266.932 129.392 267.342 129.757 267.713 130.196L267.87 130.389C268.075 130.653 268.28 130.917 268.486 131.181L269.103 131.974C269.866 133.03 270.585 134.131 271.319 135.225C271.961 136.182 272.616 137.134 273.32 138.045L273.625 138.434C275.211 140.431 277.091 142.134 279.014 143.793C280.909 145.428 282.845 147.019 284.585 148.806C283.912 148.346 283.238 147.915 282.541 147.515L281.801 147.108C279.628 145.933 277.399 144.876 275.286 143.527C275.08 143.292 274.875 143.058 274.669 142.823L274.053 142.118L274.051 142.117L273.841 141.941C273.773 141.881 273.707 141.821 273.641 141.758L273.23 141.355C272.526 140.694 271.854 140.001 271.191 139.275L270.53 138.536H270.529C270.44 138.448 270.352 138.374 270.264 138.301C270.22 138.264 270.176 138.227 270.132 138.189L270 138.067L269.473 137.571C269.123 137.233 268.776 136.882 268.44 136.515L267.946 135.953C267.726 135.689 267.506 135.392 267.311 135.087L267.125 134.781C267.095 134.692 267.051 134.604 267.007 134.517C266.963 134.429 266.92 134.341 266.891 134.254H266.892L266.889 134.25L265.127 132.056C264.834 131.692 264.54 131.331 264.247 130.972L263.366 129.905C261.926 128.208 260.352 126.693 258.643 125.278L257.903 124.677C256.361 123.488 254.786 122.365 253.204 121.258L251.619 120.156C249.582 118.724 247.597 117.293 245.809 115.62L245.455 115.282L244.791 114.652C243.352 113.254 241.944 111.65 241.257 109.743L241.112 109.297C240.782 108.143 240.762 106.938 241.147 105.826L241.229 105.606C241.34 105.329 241.503 104.998 241.669 104.665Z",
    fill: "#FDDBBF",
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.131 171.014C298.101 170.925 298.057 170.85 298.005 170.777L297.836 170.542C297.749 170.411 297.694 170.311 297.622 170.219L297.542 170.129C297.483 170.071 297.425 169.998 297.358 169.924C297.325 169.887 297.29 169.85 297.252 169.815L297.128 169.716C296.952 169.54 296.743 169.396 296.526 169.262L296.306 169.129C295.953 168.923 295.586 168.747 295.218 168.585L294.132 168.13C293.985 168.071 293.852 168.027 293.72 167.983L293.31 167.836H293.308C290.798 167.131 288.254 166.559 285.703 165.994L283.149 165.428C281.652 165.105 280.155 164.753 278.65 164.401C277.521 164.136 276.388 163.872 275.249 163.62L274.106 163.372C271.485 162.807 268.865 162.287 266.284 161.655L265.18 161.376C259.888 160.092 254.776 158.358 249.607 156.804L247.388 156.151L247.387 156.15C246.374 155.885 245.361 155.621 244.374 155.332L243.395 155.034C242.129 154.649 240.916 154.213 239.851 153.435L239.64 153.275C238.767 152.556 237.938 151.791 236.997 151.139L236.585 150.866C235.593 150.26 234.501 149.707 233.644 148.915L233.475 148.754C232.772 148.051 232.333 147.182 231.909 146.296L231.481 145.409C230.996 144.44 230.413 143.537 229.804 142.651L229.19 141.768C228.53 140.799 227.902 139.83 227.258 138.886L226.606 137.95C226.374 137.602 226.142 137.254 225.853 136.906C225.864 136.902 225.875 136.897 225.884 136.888C225.898 136.874 225.91 136.854 225.917 136.83C225.928 136.798 225.931 136.759 225.921 136.717C227.435 138.464 228.936 140.225 230.435 141.987C231.947 143.763 233.458 145.539 234.985 147.3V147.301C235.161 147.536 235.397 147.771 235.631 148.006V148.007L235.635 148.009C235.87 148.126 236.107 148.245 236.402 148.304L236.429 148.309L236.413 148.286L234.828 145.995L234.827 145.994C234.504 145.613 234.195 145.231 233.887 144.85C233.733 144.659 233.579 144.468 233.423 144.278L232.948 143.704C230.085 140.269 227.123 136.9 224.136 133.547L221.144 130.198C220.146 129.053 219.133 127.923 218.12 126.792C217.613 126.227 217.107 125.662 216.602 125.095L215.096 123.387C213.452 121.538 211.988 119.554 210.585 117.513L209.988 116.635C209.591 116.062 209.202 115.49 208.817 114.917L206.52 111.482L205.349 109.764L204.743 108.903C203.552 107.173 202.487 105.402 201.495 103.54L201.004 102.602V102.601C200.359 101.369 199.771 100.076 199.066 98.843L199.056 98.8479L199.066 98.842L199.065 98.8411L198.798 98.5442C198.263 97.9295 197.715 97.1906 197.279 96.3782L197.07 95.9661C196.425 94.4417 196.545 92.5117 198.123 91.635L198.161 91.6145H198.149C198.169 91.5992 198.19 91.5878 198.216 91.5774C198.249 91.5642 198.289 91.5493 198.34 91.5247C198.34 91.7392 198.34 91.9546 198.365 92.1702L198.399 92.3909C198.634 94.4776 199.531 96.3285 200.676 98.054C201.535 99.3481 202.535 100.573 203.501 101.773L204.45 102.966C207.378 106.665 209.947 110.589 212.589 114.463L213.727 116.119C216.245 119.87 218.898 123.532 221.646 127.103L222.83 128.627C225.803 132.481 228.879 136.232 232.156 139.782L232.813 140.49C234.354 142.135 235.896 143.734 237.556 145.249L238.275 145.894C239.097 146.613 239.965 147.332 240.838 147.973L241.212 148.243C242.137 148.911 243.062 149.624 244.027 150.186L244.443 150.416H244.444C246.296 151.342 248.237 151.638 250.267 151.816L251.142 151.886C252.273 151.937 253.358 151.988 254.477 152.118L254.958 152.18C255.926 152.312 256.861 152.575 257.789 152.872L258.714 153.177C261.08 154.057 263.346 155.094 265.701 155.849L266.172 155.996C267.552 156.407 268.933 156.804 270.305 157.193L274.394 158.345C275.774 158.727 277.139 159.093 278.504 159.46C279.187 159.644 279.87 159.828 280.554 160.013L282.615 160.576C284.875 161.193 287.092 161.9 289.341 162.499L290.308 162.749C292.247 163.249 294.33 163.66 296.282 164.342C298.111 164.982 299.824 165.86 301.191 167.272L301.459 167.561C302.456 168.675 303.277 169.965 303.922 171.314H303.923C304.077 172.185 303.962 173.011 303.734 173.833L303.629 174.186C303.373 175.11 303.071 176.036 302.881 176.961L302.807 177.359C302.675 178.153 302.741 178.914 302.857 179.691L302.984 180.474C303.248 182.192 303.644 183.844 304.098 185.504L304.569 187.17C305.78 191.355 307.301 195.434 308.212 199.701L308.386 200.558C309.26 204.873 309.774 209.233 310.125 213.639L310.265 215.531C310.265 215.701 310.266 215.872 310.32 216.044C310.178 216.017 310.037 216.002 309.896 215.988C309.823 215.98 309.749 215.973 309.676 215.964L309.457 215.929H309.456C307.051 215.636 304.705 215.107 302.359 214.345L302.008 210.479C301.597 205.906 301.186 201.332 300.696 196.798L300.481 194.858C300.085 191.246 299.556 187.635 299.044 184.024L298.543 180.412C298.075 176.899 297.722 173.384 296.905 169.927C297.363 170.219 297.766 170.622 298.112 171.083L298.132 171.111V171.018L298.131 171.014Z",
    fill: "#FFC291",
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 150.124C239.808 150.066 240.201 150.197 240.567 150.401C240.75 150.504 240.926 150.625 241.093 150.749L241.564 151.12C242.5 151.835 243.489 152.605 244.677 152.844L244.917 152.884C245.592 152.972 246.283 153.016 246.972 153.068C247.49 153.106 248.007 153.149 248.518 153.217L249.027 153.295H249.028C250.312 153.449 251.551 153.693 252.784 154.026L253.312 154.176H253.313C253.384 154.19 253.448 154.233 253.498 154.288C253.548 154.344 253.584 154.412 253.598 154.476C253.613 154.54 253.604 154.598 253.571 154.636C253.538 154.674 253.476 154.696 253.376 154.682H253.377C252.195 154.476 251.012 154.271 249.83 154.144L249.324 154.095C248.141 153.992 246.96 153.934 245.778 153.803L245.272 153.742C243.983 153.566 243.104 152.981 242.106 152.218H242.107C241.917 152.071 241.722 151.891 241.522 151.703C241.322 151.515 241.116 151.319 240.903 151.139C240.478 150.78 240.022 150.484 239.521 150.453C239.463 150.395 239.392 150.31 239.357 150.239C239.348 150.222 239.342 150.205 239.339 150.191C239.335 150.176 239.334 150.164 239.337 150.154C239.339 150.146 239.344 150.138 239.353 150.133C239.361 150.128 239.374 150.126 239.39 150.125L239.4 150.124Z",
    fill: "#C3825D",
    stroke: "#FE9278",
    strokeWidth: 0.0226957
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_150_150)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 212,
    rx: 20,
    fill: "url(#paint5_linear_150_150)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 212,
    rx: 20,
    fill: "url(#paint6_linear_150_150)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_150_150",
    x: 185.785,
    y: 39.9457,
    width: 166.486,
    height: 192.391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.0543
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.0543
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.429005 0 0 0 0 0.151766 0 0 0 0 0.644231 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_150_150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_150_150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_150_150",
    x1: 9,
    y1: 32.5,
    x2: 308.926,
    y2: 225.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C49CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487354,
    stopColor: "#9F3EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832128,
    stopColor: "#D6A1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_150_150",
    x1: 223.015,
    y1: 36.4266,
    x2: 291.72,
    y2: 144.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341176,
    stopColor: "#E7B94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541176,
    stopColor: "#F3CD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74902,
    stopColor: "#FDDD72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788235,
    stopColor: "#F9D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839216,
    stopColor: "#ECC660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901961,
    stopColor: "#D8AA4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960784,
    stopColor: "#BC842D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA6B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_150_150",
    x1: 237.108,
    y1: 63.4386,
    x2: 286.805,
    y2: 125.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341176,
    stopColor: "#FFC641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501961,
    stopColor: "#F3CD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.670588,
    stopColor: "#FDDD72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721569,
    stopColor: "#FFD03F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788235,
    stopColor: "#ECC660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.870588,
    stopColor: "#D8AA4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94902,
    stopColor: "#BC842D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA6B1A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_150_150",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(285.257 118.679) scale(7.60112 7.60106)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_150_150",
    x1: 241.327,
    y1: 73.7034,
    x2: 283.153,
    y2: 109.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_150_150",
    x1: 318.431,
    y1: 173.5,
    x2: 299.526,
    y2: -23.5997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#590080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#581773"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_150_150",
    x1: 163.183,
    y1: 288.187,
    x2: 163.183,
    y2: -100.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.121042,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_150_150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 212,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_150_150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 212,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFlipBack1);
export default __webpack_public_path__ + "static/media/bg-flip-back-1.9820ca12db0fc56bce11f91cdeeb5a1b.svg";
export { ForwardRef as ReactComponent };